export default {
    "accountValidateMsg" : "يجب أن يحتوي الحساب على 6 - 30 حرفًا، بما في ذلك الأحرف والأرقام والرموز (\".\"، \"_\"، \"@\"). يجب أن يكون الحرف الأول رقمًا أو حرفًا كبيرًا.",
    "storeSuccess" : "نجح الشحن",
    "editAccountTips" : "يرجى إدخال اسم صالح للحساب",
    "editPwdTips" : "يرجى إدخال كلمة سر صالحة",
    "editRepeatPwdTips" : "يرجى إدخال كلمة السر ثانية",
    "pwdRepeatTips" : "كلمتيّ السر غير متطابقتين",
    "changePwdSucc" : "تم تغيير كلمة السر الخاصة بك",
    "bindEmail" : "ربط البريد الإلكتروني",
    "errorVrifyCodeTips" : "خطأ برمز التحقق",
    "slectQuessionTips" : "الرجاء تحديد سؤال الأمان؟",
    "answerTips" : "الرجاء إدخال الإجابة",
    "twoAnswerTips" : "الرجاء تحديد أسئلة الأمان التي تم إنشاؤها وإدخال الإجابات الصحيحة",
    "realNameValidateTips" : "الاسم الحقيقي (من 4 إلى 60 حرفًا)",
    "phoneValidateTips" : "رقم الهاتف (من 6 إلى 18 رقمًا)",
    "areaSelectTips" : "الرجاء تحديد المنطقة",
    "iDCardValidataTips" : "رقم الهوية (من 1 إلى 60 رقمًا)",
    "changeProfileSucc" : "تم حفظ المعلومات المحدثة",
    "editVrfCodeTips" : "الرجاء إدخال رمز التحقق",
    "securityQuestionTips" : "يرجى إنشاء أسئلة الأمان لتعزيز أمان حسابك. عندما تنسى كلمة السر الخاصة بك، سيمكنك الإجابة على الأسئلة لإعادة تعيين كلمة السر.",
    "validateQuessionTips" : "الرجاء تحديد سؤالين مختلفين والتحقق. يمكنك إعادة إنشاء الأسئلة بعد التحقق.",
    "originPwd" : "كلمة السر الأصلية",
    "newPwd" : "كلمة السر الجديدة",
    "changePwdSuccess" : "تم تغيير كلمة السر. نقترح عليك تسجيل الدخول مرة أخرى الآن لحفظ تقدمك.",
    "accountName" : "اسم الحساب",
    "password" : "من فضلك أدخل كلمة السر",
    "repeatPassword" : "من فضلك أدخل كرر كلمة السر",
    "findPwdTips" : "الرجاء إدخال الحساب الذي تريد استرداد كلمة السر الخاصة به",
    "submit" : "تسليم",
    "send" : "إرسال",
    "modify" : "تعديل",
    "haveAgree" : "أوافق",
    "and" : "و",
    "privacyPolicy" : "سياسة الخصوصية",
    "completeness" : "الإكمال",
    "gender" : "الجنس",
    "male" : "ذكر",
    "female" : "أنثى",
    "birthday" : "تاريخ الميلاد",
    "phone" : "رقم الهاتف",
    "region" : "المنطقة",
    "ID" : "المعرّف",
    "accountSetting" : "إعدادات الحساب",
    "upgrade" : "ترقية",
    "profile" : "الملف الشخصي",
    "changePassword" : "تغيير كلمة السر",
    "securityQuestion" : "أسئلة الأمان",
    "creatework_headerTitle" : "إنشاء تذكرة",
    "mylist_headerTitle" : "تذكرتي",
    "bindEmailTips" : "قم بتأكيد بريدك الإلكتروني من أجل أمان حسابك. إذا نسيت كلمة السر الخاصة بك، سنرسل إليك بريدًا إلكترونيًا على عنوان البريد الإلكتروني هذا.",
    "enterEmailVrfcationTips" : "الرجاء إدخال رمز التحقق هنا.",
    "cancel" : "إلغاء",
    "bindTps" : "اربط حسابك لتلعب اللعبة على أجهزة متعددة!",
    "login" : "تسجيل الدخول",
    "logout" : "تسجيل الخروج",
    "bind" : "ربط الحساب",
    "feedback" : "آراء المستخدمين",
    "terms" : "الاتفاقيات",
    "tips" : "ملحوظة",
    "debindTips" : "قد يؤدي فك الارتباط إلى فقدان البيانات. هل أنت متأكد أنك تريد فك الارتباط؟",
    "debindText" : "فك الارتباط",
    "guestSwitchTips" : "تم الكشف عن حساب زائر. بعد تسجيل الدخول، ستفقد بيانات حساب الضيف الخاص بك. استمرار؟",
    "register" : "إنشاء حساب",
    "realName" : "الاسم الحقيقي",
    "enterEmailTips" : "يرجى إدخال بريدك الإلكتروني",
    "emailVAlidateMsg" : "بريد إلكتروني خاطئ",
    "editEmaileTips" : "يرجى إدخال بريدك الإلكتروني",
    "checkServiceTips" : "يرجى قراءة شروط الاستخدام وسياسة الخصوصية أولاً.",
    "brithdayValidateTips" : "أدخل تاريخ ميلادك",
    "facebookValidateTips" : "حساب Facebook (من 1 إلى 60 حرفًا)",
    "eritOriginPwdTips" : "كلمة السر الأصلية",
    "submitSuccess" : "تم التسليم",
    "rebindEmail" : "تغيير البريد الإلكتروني المرتبط",
    "bindEmailSuccess" : "تم ربط البريد الإلكتروني: \$ email </br> يرجى استخدام بريد إلكتروني مرتبط للتحقق. يمكنك إعادة تعيين البريد الإلكتروني الخاص بك بعد التحقق.",
    "reSetSecurityQuessoon" : "لقد أنشأت أسئلة الأمان بنجاح </br> </br> الرجاء تحديد أسئلة مختلفة والتحقق. يمكنك إعادة إنشاء الأسئلة بعد التحقق.",
    "canotModifyTips" : "غير مسموح بإجراء التغييرات بعد الإرسال، هل أنت متأكد من الإرسال؟",
    "rebindEmailTips" : "بريدك الإلكتروني هو: :\$email ، يرجى النقر هنا للحصول على رمز التحقق",
    "reGetVrfCode" : "احصل على رمز",
    "findPwdWayTips" : "الرجاء تحديد إحدى الطرق التالية",
    "emailWay" : "الاسترداد عن طريق البريد الإلكتروني الضامن",
    "emailWayTips" : "ستتلقى رسالة تأكيد بالبريد الإلكتروني وبعد ذلك يمكنك إعادة تعيين كلمة السر",
    "quessionWay" : "الاسترداد عن طريق أسئلة الأمان",
    "quessionWayTips" : "أجب عن أسئلة الأمان التي تم إنشاؤها ثم أعد تعيين كلمة السر",
    "resetPwdBtn" : "أعد تعيين كلمة السر",
    "lastStep" : "السابق",
    "sendEmailTips" : "لقد أرسلنا إليك بريدًا إلكترونيًا إلى \$email.<br> يُرجى إدخال رمز التحقق الذي تلقيته هنا.",
    "setNewPwdTips" : "تهانينا! <br> تم التحقق من هوية المستخدم. الآن يمكنك إعادة تعيين كلمة السر الخاصة بك.",
    "termsOfUse" : "شروط الاستخدام",
    "copy_success" : "تم النسخ",
    "creatework_create" : "تذكرة",
    "creatework_createHolder" : "اختر النوع",
    "creatework_title" : "الموضوع",
    "creatework_titleHolder" : "يرجى إدخال موضوع",
    "creatework_detail" : "التفاصيل",
    "creatework_detailHolder" : "يجب أن يحتوي الوصف على أكثر من 200 حرف",
    "creatework_uploadTips" : "يرجى رفع ملفات من نوع jpg/png فقط. يجب أن يكون الملف المرفوع أصغر من 5 ميغا بايت.",
    "creatework_selectBox_selectTile" : "النوع",
    "creatework_goGame" : "عودة",
    "creatework_history" : "السجل",
    "mylist_noYet" : "لا توجد سجلات",
    "mywork_solved" : "تم حل المشكلة؟",
    "mywork_service" : "قيّمنا",
    "mywork_messageHolder" : "رسالة جديدة",
    "mywork_score" : "درجة التقييم",
    "mywork_confirm" : "تأكيد",
    "creatework_selectBox_selectList3" : "غير ذلك",
    "creatework_selectBox_selectList2" : "الحساب",
    "close" : "إغلاق",
    "creatework_gameHolder" : "اختر اللعبة",
    "creatework_serverHolder" : "اختر الخادم",
    "contactService" : "التواصل مع خدمة العملاء",
    "FAQ" : "أسئلة شائعة",
    "creatework_game" : "اللعبة:",
    "creatework_server" : "الخادم:",
    "creatework_role" : "الشخصية:",
    "selectRoleName" : "اختر الشخصية",
    "creatework_noRole" : "لا توجد شخصيات",
    "creatework_noGame" : "قائمة الألعاب فارغة",
    "creatework_noServer" : "قائمة الخوادم فارغة",
    "termText" : "أوافق على {mainHost}",
    "backLogin" : "رفض",
    "creatework_roleHolder" : "يمكن الوصول بعد اختيار شخصيتك",
    "findPwdFailTips" : "لم تقم بتعيين أسئلة الأمان. يرجى الاتصال بخدمة العملاء.",
    "payMall" : "المتجر",
    "selectPayment" : "المبلغ",
    "plzSelectPayWay" : "اختر وسيلة الدفع",
    "gainPlus" : "احصل على إضافي",
    "gainMorePlus" : "أضف المزيد",
    "gainMostPlus" : "الحد الأقصى",
    "plzSelectPayType" : "اختر طريقة الدفع",
    "roleName" : "الشخصية",
    "payWay" : "قناة الدفع",
    "plzSelectOtherWay" : "قناة الدفع البديلة",
    "payment" : "المبلغ",
    "compensateTips" : "سيتم إرجاع الفائض إليك بعملة \$gameCode",
    "extaGain" : "الجوائز الإضافية",
    "gameGold" : "عملة اللعبة",
    "compensate" : "تعويض",
    "payWayPlus" : "مكافآت القناة",
    "neddPay" : "الدفع",
    "submitOrder" : "تسليم",
    "screenshotTips" : "ملاحظة: خذ لقطة لشاشة طلبك في حالة حدوث خطأ في المعاملة.",
    "storeFail" : "فشل الشحن",
    "storeFailTips" : "فشلت المعاملة. يرجى تقديم الطلب مرة أخرى أو الاتصال بخدمة العملاء.",
    "storeAcceptance" : "جاري المعالجة",
    "storeSuccessTips" : "ستتم المعاملة في خلال 15 دقيقة",
    "orderNumber" : "رقم الطلب",
    "buyProduct" : "السلعة المشتراة",
    "transactionAmount" : "المبلغ",
    "failReason" : "السبب",
    "payOntherORder" : "طلب جديد",
    "reStore" : "اشحن ثانية",
    "confirm" : "تأكيد",
    "switch" : "تغيير الحساب",
    "completeTips" : "يرجى ملء معلوماتك الشخصية. <mark class = \"yellowMarkColor\"> لن تكون المعلومات قابلة للتعديل مرة أخرى </ mark>. عندما تحاول استرداد حساب مفقود، سيُطلب منك تقديم معلومات شخصية صحيحة.",
    "creatework_selectBox_selectList0" : "خطأ باللعبة",
    "creatework_selectBox_selectList1" : "خطأ بالدفع",
    "creatework_selectBox_selectList4" : "خطأ بالترجمة",
    "mywork_solvedText" : "تم حل المشكلة",
    "browserPayErrBtnText" : "خطأ بالدفع",
    "browserPaySucBtnText" : "اكتمل الدفع",
    "browserPayingTips" : "جاري إعادة التحويل إلى منصة الطرف الثالث.<br/>يمكن إغلاق تلك النافذة بعد الدفع.",
    "price_list_empty" : "لا يوجد مبلغ قابل للاختيار",
    "pointCardTips" : "ملاحظة: هذا العنصر يدعم فقط بطاقة \n\$paymentAmount",
    "forgetPwd" : "نسيت كلمة السر؟",
    "payCenter" : "مركز الشحن",
    "willGet" : "ستحصل على",
    "goods" : "أداة",
    "discount" : "الجوائز الإضافية",
    "payDiscount" : "تعويض",
    "payDiscountTips" : "النقاط الزائدة ستتحول إلى ماسات",
    "hasQuestionPlease" : "إذا كان لديك أي تساؤلات، يرجى",
    "pwdValidateMsg" : "كلمة السر يجب أن تحتوي على 6 إلى 20 حرفًا",
    "payWayPlusC" : "مكافآت القناة",
    "fwtk" : "شروط الخدمة",
    "yszc" : "سياسة الخصوصية",
    "exchange" : "مبادلة رمز الهدايا",
    "remember" : "تذكر اختياري",
    "thirdInfo" : "عن الحساب",
    "thirdInfoContent" : "يرجى ربط حسابك في مركز المستخدم داخل اللعبة. بعد ذلك، قم بتسجيل الدخول إلى اللعبة باستخدام الحساب المرتبط.",
    "unLink" : "هذه الطريقة غير مدعومة حاليًا",
    "favour" : "حفظ",
    "goStoreTip" : "الرجاء المتابعة إلى صفحة الدفع",
    "go" : "اذهب",
    "otherLogin" : "طرق تسجيل الدخول الأخرى",
    "qrCodeTip" : "امسح رمز الاستجابة السريعة للبدء!",
    "favourTip" : "احفظ الصفحة للعب مرة أخرى في وقت لاحق!",
    "share" : "مشاركة",
    "landscapeTip" : "يرجى المتابعة في الوضع الرأسي",
    "leaveTip" : "الخروج من اللعبة؟",
    "selectRole" : "يرجى اختيار الشخصية",
    "selectMoney" : "يرجى اختيار الأداة المرغوب في شرائها",
    "seletGameInfoFirst" : "يرجى اختيار لعبة",
    "lowerIE" : "إصدار IE لديك قديم جدًا",
    "linkTermText" : "لقد وافقت على [شروط الاستخدام] و [سياسة الخصوصية] الخاصة بـ{mainHost}",
    "download" : "تحميل",
    "favourAndDownloadTip" : "ضع إشارة مرجعية لهذه الصفحة في المتصفح أو حمّلها على جهاز الكمبيوتر",
    "payReward" : "مكافأة الشحن",
    "hasEqualReward" : "ضِعف الشحن وغيره من التخفيضات تنطبق على وسيلتيّ الدفع",
    "payBtnText" : "الدفع",
    "storeHoaveReward" : "مكافآت الشحن",
    "showMorePayWay" : "المزيد من الوسائل",
    "needPaymentCount" : "المبلغ",
    "orderDetail" : "التفاصيل",
    "selectPayWayPlz" : "اختر وسيلة الدفع",
    "countryCode" : "رمز الدولة",
    "deleteaccount_title1" : "حذف الحساب",
    "deleteaccount_title2" : "طلب حذف الحساب",
    "deleteaccount_step1_1" : "سيتم تجميد حسابك لمدة 14 يومًا منذ حذف الحساب. بعد 14 يومًا، سيتم حذف حسابك نهائيًا. لن تتمكن من تسجيل الدخول بحسابات التواصل الاجتماعي.",
    "deleteaccount_step1_2" : "يمكنك إلغاء الحذف في غضون 14 يومًا من خلال الرابط أدناه:",
    "deleteaccount_step1_3" : "بمجرد الحذف، لن تتمكن من استعادة معلومات حسابك، ولن يتم تعويضك عن أي خسارة ناتجة عن حذف الحساب.",
    "deleteaccount_step1_4" : "هل انت متأكد انك تريد حذف حسابك؟",
    "deleteaccount_step2_1" : "يرجى تأكيد رغبتك في حذف حسابك وشخصيتك.",
    "deleteaccount_step2_2" : "يرجى كتابة \\\\&quot;Delete\\\\&quot; لإكمال الحذف.",
    "deleteaccount_step3" : "سيتم حذف حسابك في غضون 14 يومًا.",
    "accountrecovery_note" : "ملحوظة:",
    "accountrecovery_tips" : "يمكنك فقط إلغاء حذف الحساب خلال فترة التجميد التي تصل إلى 14 يومًا.",
    "accountrecovery_Submitted2" : "تم تقديم الإلغاء. سيتم استعادة حسابك لاحقًا.",
    "accountrecovery_Failed" : "فشل",
    "accountrecovery_Failed_1" : "حالة الحساب طبيعية. يمكنك تسجيل الدخول.",
    "accountrecovery_Failed_2" : "لم يتم العثور على معلومات الشخصية.",
    "accountrecovery_success" : "تمت استعادة الحساب",
    "account_normal" : "حالة الحساب طبيعية. لا حاجة للاستعادة.",
    "account_unablerestore" : "تم حذف الحساب. لا يمكن الاستعادة.",
    "accountrecovery_roleHolder" : "أدخل اسم شخصيتك",
    "accountrecovery_headerTitle" : "إبطال حذف الحساب",
    "guideTitle" : "فشلت عملية الشراء. يرجى الاتصال بخدمة العملاء الخاصة بنا.",
    "accountFix" : "استرجاع الحساب",
    "inputAccount" : "يرجى إدخال اسم الحساب الذي ترغب في استرجاعه",
    "applyForAccountFix" : "استرجاع الحساب",
    "nonEnterItem" : "المعلومات المراد إضافتها: تاريخ التسجيل؛ رقم الموديل؛ اسم الجهاز؛ رقم جواز السفر أو بطاقة الهوية، البريد الإلكتروني لجهة الاتصال؛ يرجى ملء الفراغات",
    "resetOT" : "انتهت المهلة، يرجى الإرسال للمراجعة مرة أخرى",
    "addOT" : "انتهت المهلة، يرجى تقديم المعلومات الإضافية مرة أخرى",
    "errorPwd" : "كلمة السر يجب أن تتكون من 6-20 حرفًا ورمزًا، \".\", \"_\", \"@\"",
    "verifyAccount" : "معلومات الحساب مفقودة، يرجى التحقق ثانية.",
    "selectRegisterTime" : "يرجى اختيار تاريخ تسجيلك",
    "enterBindEmail" : "يرجى إدخال بريدك الإلكتروني الذي تم التحقق منه.",
    "enterUsedPhoneType" : "يرجى إدخال موديل هاتفك",
    "enterIdfaGpid" : "يرجى إدخال الـUDID الخاص بهاتفك",
    "enterContactEmail" : "تنسيق غير صحيح لعنوان البريد الإلكتروني لجهة الاتصال؛ يرجى إعادة الإدخال",
    "confirmTermsPrivacy" : "يرجى قراءة شروط الخدمة وسياسة الخصوصية والموافقة عليها.",
    "enterRechargeRemark" : "الرجاء إدخال سجل الشحن الخاص بك.",
    "uploadImg" : "يرجى تحميل صورة من هويتك، الحد الأقصى للحجم هو 2 ميغا بايت",
    "selectIDType" : "الرجاء تحديد نوع وثيقة الهوية الخاصة بك.",
    "enterIDNum" : "الرجاء إدخال رقم جواز السفر أو رقم بطاقة الهوية.",
    "enterIP" : "الرجاء إدخال عنوان IP الذي استخدمته للتسجيل.",
    "enterQueryNum" : "الرجاء إدخال معرف المراجعة",
    "enterQueryPwd" : "الرجاء إدخال كلمة مرور المراجعة",
    "errorQueryItem" : "معرف مراجعة أو كلمة مرور غير صحيحة ، يرجى المحاولة ثانية",
    "enterPassword" : "الرجاء إدخال كلمة مرور جديدة.",
    "enterPasswordAgain" : "يرجى تأكيد كلمة السر الجديدة.",
    "enterPasswordNonSame" : "كلمتيّ السر غير متطابقتين",
    "enterEmail" : "الرجاء إدخال عنوان البريد الإلكتروني",
    "sendSuccess" : "تم إرسال البريد الإلكتروني",
    "enterCode" : "الرجاء إدخال رمز التحقق",
    "errorCode" : "رمز التحقق غير صحيح",
    "selectQuest" : "الرجاء اختيار سؤال الأمان",
    "enterAnswer" : "الرجاء إدخال الإجابة",
    "selectDifferQuest" : "الرجاء تحديد 3 أسئلة أمنية وأجوبتها",
    "addSuccess" : "تم تقديم المعلومات الخاصة بك.",
    "picFormt" : "يجب أن يكون تنسيق الصورة jpg أو png أو gif",
    "countdownBefore" : "العد التنازلي لإعادة التعيين",
    "countdownAfter" : "(ستنتهي صلاحية الرابط في 00:00:00 ، يرجى تقديم طلبك مرة أخرى)",
    "uploadDone" : "تم الرفع",
    "uploadFail" : "فشل الرفع",
    "applySuccess" : "تم قبول الطلب",
    "applyFailed" : "تم رفض الطلب",
    "resetQuestAlterFailed" : "فشل تغيير سؤال الأمان.",
    "resetQuestError" : "خطأ في إدخال البيانات.",
    "resetQuestNone" : "طلب الاستفسار غير موجود.",
    "resetQuestAltered" : "تم تغيير أسئلة الأمان.",
    "illegalOperation" : "عملية غير مصرّح بها",
    "queryNotExist" : "رقم الاستفسار غير موجود.",
    "queryPasswordError" : "خطأ في البحث عن كلمة السر",
    "auditing" : "في انتظار الموافقة",
    "notPass" : "مرفوض",
    "suppleInformation" : "إرسال المعلومات المكملة",
    "suppleInformationUnHandle" : "تم تقديم المعلومات المكمّلة، في انتظار المعالجة من قِبَل خدمة العملاء.",
    "suppleInformationTimeout" : "تم تخطي الحد الزمني لتقديم المعلومات المكمّلة.",
    "repairedAccountSuccess" : "اكتمل إصلاح الحساب.",
    "repairedAccountLost" : "فشلت عملية إصلاح الحساب.",
    "loginStateNone" : "لم يتم تسجيل الدخول أو انتهت الجلسة.",
    "repairedAccountTimeout" : "انتهت مدة إصلاح الحساب.",
    "changePasswordSucc" : "تم تغيير كلمة السر.",
    "emailSendFailed" : "فشل إرسال البريد.",
    "emailSendLimit" : "قد لا يتلقى صندوق البريد أي رموز تحقق أخرى اليوم.",
    "repairedAccountTimeout2" : "Illegal operation account repair duration has expired.",
    "emailCodeSended" : "تم إرسال رمز التحقق عبر البريد الإلكتروني.",
    "alterSuccess" : "تم حفظ التغيير",
    "questionAlterSuccess" : "تم تغيير سؤال الأمان.",
    "username" : "اسم الحساب",
    "code" : "الرجاء إدخال رمز التحقق هنا",
    "selectServiceType" : "الرجاء تحديد نوع الخدمة",
    "submitForm" : "أرسل النموذج",
    "apply" : "تقديم",
    "reviewApplicationStatus" : "مراجعة حالة التطبيق",
    "instantReviewOfTheStatus" : "مراجعة فورية للحالة",
    "reviewStatus" : "مراجعة الحالة",
    "backToLogin" : "العودة إلى تسجيل الدخول",
    "previous" : "السابق",
    "applyDesc" : "الرجاء إدخال المعلومات حتى نتمكن من المساعدة. يجب ملء الفراغات بعلامة *. إذا كانت هذه المعلومات مفقودة في حسابك ، فيرجى إدخال \"لا شيء\".",
    "additionalServices" : "خدمات إضافية",
    "resetSecurityEmail" : "إعادة تعيين البريد الإلكتروني الضامن",
    "resetSecurityQuest" : "إعادة تعيين أسئلة الأمان",
    "registrationDate" : "تاريخ التسجيل",
    "month" : "الشهر",
    "year" : "السنة",
    "emailBound" : "البريد الإلكتروني المرتبط",
    "modelNumber" : "نوع الهاتف",
    "deviceName" : "اسم الهاتف",
    "provideRecharge" : "يرجى تقديم سجل شحن مفصل متكامل، بما في ذلك الوقت والطريقة والمبلغ ورقم الطلب ومعرف المعاملة حتى نتمكن من تأكيدها.",
    "selectCountry" : "المنطقة",
    "passportID" : "رقم جواز السفر / بطاقة الهوية",
    "upload" : "رفع",
    "del" : "حذف",
    "pleaseUpload" : "يرجى تحميل صورة ضوئية من هويتك، بحد أقصى 20 ميغا بايت",
    "uploadAgain" : "رفع ثانية",
    "enterDesc" : "الرجاء إدخال أي معلومات تثبت ملكية الحساب",
    "contactEmail" : "البريد الإكتروني للتواصل",
    "applyNoteAttr" : "ملحوظة",
    "applyNoteDate" : "يرجى تقديم عنوان البريد الإلكتروني الخاص بك حتى تتمكن من تلقي نتائج طلبك",
    "agree" : "أوافق على",
    "UJOYTerms" : "شروط الاستخدام",
    "privacy" : "سياسة الخصوصية",
    "reviewStatusOfAccountFix" : "مراجعة حالة إصلاح الحساب",
    "enterReviewID" : "الرجاء إدخال معرف المراجعة",
    "enterReviewPwd" : "الرجاء إدخال كلمة مرور المراجعة",
    "review" : "مراجعة",
    "reviewNoteAttr" : "ملحوظة",
    "reviewNoteData" : "تحقق من البريد الإلكتروني للتواصل في حالة نسيان معرف المراجعة وكلمة مرورها",
    "haveResetInfo" : "لقد قمت بإعادة تعيين المعلومات الخاصة بك",
    "resetProfile" : "إعادة تعيين معلوماتك",
    "desc" : "تهانينا! تمت الموافقة على الطلب! يرجى إعادة تعيين معلوماتك.",
    "changePwd" : "تغيير كلمة السر",
    "resetPwd" : "إعادة تعيين كلمة السر",
    "reset" : "إعادة تعيين",
    "enterNewPwd" : "يرجى إدخال كلمة سر جديدة",
    "confirmNewPwd" : "يرجى التأكيد على كلمة السر الجديدة",
    "successResetPwd" : "تم إعادة تعيين كلمة السر بنجاح",
    "bindSecurityEmail" : "ربط بريد إلكتروني ضامن",
    "resetPwdDesc" : "يستخدم لإعادة تعيين كلمة السر في حالة نسيانها أو سرقة الحساب",
    "bindCommon" : "ربط",
    "sendCommon" : "إرسال",
    "enterVcode" : "الرجاء إدخال رمز التحقق",
    "successResetEmail" : "تم إعادة تعيين البريد الإلكتروني الضامن",
    "resetQuest" : "إعادة تعيين أسئلة الأمان",
    "resetQuestDesc" : "تستخدم لإعادة تعيين كلمة السر في حالة نسيانها أو سرقة بيانات الحساب",
    "successResetQuest" : "تم إعادة تعيين أسئلة الحماية بنجاح",
    "hide" : "إخفاء",
    "addRegisterTime" : "وقت التسجيل:",
    "modelNum" : "الرقم التسلسلي للهاتف: IDFA/GPID",
    "registrationIP" : "الـIP الذي تم التسجيل منه:",
    "addRechargeRecord" : "سجل الشحن:",
    "serviceReply" : "إجابة من خدمة العملاء:",
    "addDataLimitTime" : "تاريخ إضافة معلومات إضافية:",
    "addMoreInfo" : "أضف المزيد من المعلومات",
    "applicationSubmit" : "تم تقديم الطلب",
    "underReviewStatus" : "ملفك الشخصي قيد المراجعة، سوف تتلقى الرد في يوم العمل التالي. حالة المراجعة:",
    "reviewID" : "معرّف المراجعة",
    "reviePwd" : "كلمة سر المراجعة",
    "enterReviewIDNPwd" : "أدخل معرّف وكلمة سر المراجعة لفحص حالة المراجعة.",
    "homepage" : "الصفحة الرئيسية",
    "checkEmailAttr" : "ملحوظة",
    "checkEmailData" : "تحقق من البريد الإلكتروني لجهة الاتصال في حالة نسيان معرف المراجعة وكلمة مرور المراجعة.",
    "underReview" : "قيد المراجعة",
    "underReviewReply" : "ملفك الشخصي قيد المراجعة وسنقوم بالرد في أقرب وقت ممكن. شكرا لك على صبرك!",
    "failed" : "فشل الطلب",
    "reason" : "السبب: ### لذلك فشل الطلب، يرجى تقديم المعلومات الصحيحة، وسيساعدك فريقنا. شكرا لتعاونكم!",
    "underReviewAdd" : "ملفك الشخصي قيد المراجعة. جزء من المعلومات مفقود أو غير متسق، يرجى إضافة مزيد من المعلومات لنا للتأكيد!",
    "addInfoRequired" : "مطلوب معلومات إضافية",
    "dateForAddInfo" : "تاريخ إضافة معلومات إضافية:",
    "addInfo" : "معلومات إضافية",
    "addInfoSubmit" : "تم تقديم المعلومات الإضافية! شكرا لك على صبرك!",
    "hasBeenRepaired" : "تم إصلاح الحساب",
    "opExpired" : "انتهت صلاحية عملية إصلاح الحساب",
    "approved" : "تم القبول",
    "haveSubmitted" : "لقد قدّمت بنجاح",
    "sessionExpired" : "لم تقم بتسجيل الدخول بعد أو انتهت صلاحية الجلسة",
    "submitted" : "تم التسليم",
    "addItemRegisterDate" : "البريد الإلكتروني:",
    "addItemDeviceNumber" : "UDID:",
    "reasonItemPwd" : "رقم معرف غير متسق",
    "addItemIDPhoto" : "صورة رقم المعرف",
    "idfaTitle" : "كيف تحصل على الرقم التسلسلي للهاتف IDFA أوGPID؟",
    "idfaSubTitle1" : "لمستخدمي IOS - العثور على IDFA الخاص بك",
    "idfaSubTitle1Desc1" : "1. قم بتحميل التطبيق 【<em>MyIDFA</em>】من متجر التطبيقات",
    "idfaSubTitle1Desc2" : "2. افتح هذا <em>التطبيق</em> وستجد الـ<em>IDFA</em> الخاص بهاتفك.",
    "idfaSubTitle2" : "لمستخدمي أندرويد - العثور على GPID الخاص بك",
    "idfaSubTitle2Desc1" : "1. انقر على زر <em>“الإعدادات”</em>",
    "idfaSubTitle2Desc2" : "2. انقر على أيقونة <em>“Google”</em> تحت صفحة <em>الحسابات</em>",
    "idfaSubTitle2Desc3" : "3. ثم انقر على أيقونة <em>“Ads”</em> وستجد الـ<em>GPID</em> الخاص بك.",
    "uploadIDCard" : "يرجى تحميل صورة ضوئية من هويتك، بحد أقصى 2 ميغا بايت",
    "uploadTipsBefore" : "يجب ألا يكون حجم الملف أكبر من",
    "uploadTipsAfter" : "م",
    "submitError" : "خطأ ناتج عن عدم وجود رقم معرف أو معلومات حساب غير صحيحة.",
    "applyLimitError" : "تم تجاوز حد التقدم اليومي. (3 مرات كل يوم)",
    "applyDisabled" : "يمكنك التقديم مرة واحدة فقط كل 10 دقائق.",
    "inputDataError" : "البيانات غير مكتملة.",
    "dataException" : "استثناء البيانات",
    "picSizeLimit" : "يجب ألا يتجاوز حجم ملف الصورة 5 ميغا بايت",
    "picTypeLimit" : "قم برفع ملفات JPG و PNG و GIF فقط",
    "picNull" : "الصورة خالية",
    "alteredPassword" : "تم تغيير كلمة السر.",
    "inputError" : "خطأ في الإدخال.",
    "pwdChangefailed" : "فشل تغيير كلمة السر.",
    "sendEmailCodeDisabled" : "لا يمكن إرسال رمز التحقق إلا مرة أخرى بعد فترة زمنية.",
    "alteredEmail" : "تم تغيير البريد الإلكتروني.",
    "inputEmailError" : "خطأ في إدخال البريد الإلكتروني",
    "operationFailed" : "خطأ في العملية",
    "codeNull" : "لم تقم بإدخال رمز التحقق حتى الآن.",
    "findPwd" : "نسيت كلمة السر",
    "findAccountAndPwd" : "نسيت الحساب/كلمة السر",
    "usualDeviceNum" : "الرقم التسلسلي للهاتف: IDFA/GPID",
    "usualPhoneNum" : "اسم الهاتف",
    "registerTimeError" : "تاريخ تسجيل غير متسق؛",
    "bindEMailError" : "بريد إلكتروني مرتبط غير متسق؛",
    "rechargeRecordError" : "سجل الشحن غير متسق؛",
    "registerIPError" : "الـIP الذي تم التسجيل منه غير متسق؛",
    "deviceNumError" : "IDFA /GPID غير متسق؛",
    "deviceModelError" : "نوع الجهاز غير متسق؛",
    "confirmTerms" : "الرجاء الموافقة على شروط الخدمة",
    "applyFixAccount" : "إذا لم تنجح الأساليب المذكورة أعلاه ، يمكنك التقدم بطلب <span> استرداد الحساب</span>.",
    "findPwdByFixAccount" : "يُنصح بتعيين بريد إلكتروني ضامن لاستعادة الحساب.",
    "connectFail" : "فقد الاتصال بخدمات Google، يرجى المحاولة مرة أخرى",
    "h5_favour_has_gift" : "التسجيل بالإشارات المرجعية للمتصفح! (هذا الحساب حصل على المكافأة بالفعل)",
    "h5_favour_get_gift" : "تهانينا! لقد حصل على مكافأة، يرجى تفحصها داخل اللعبة.",
    "h5_get_gift_fault" : "لا يمكن الاستلام. يرجى المحاولة مرة أخرى لاحقًا والاتصال بخدمة العملاء إذا ظلت المشكلة قائمة.",
    "h5_favour_please_select" : "الرجاء اختيار الخادم / الشخصية",
    "h5_favour_login_get" : "سجل الدخول وقم بالإضافة إلى الإشارات المرجعية للمتصفح لتحصل على مكافأة!",
    "h5_favour_tip" : "أضف إلى الإشارات المرجعية للمتصفح لتحصل على مكافأة!",
    "h5_favour_select_serve" : "الرجاء اختيار الخادم",
    "h5_favour_select_role" : "يرجى اختيار الشخصية",
    "store_product_paytype_error" : "لا يمكنك شراء العنصر المحدد من خلال طريقة الدفع هذه.",
    "SwitchWithThirdWay" : "تغيير إلى \${type}",
    "moreGame" : "المزيد من الألعاب",
    "serviceTitle" : "الخدمة",
    "h5_download_login" : "الرجاء تسجيل الدخول أولا.",
    "h5_download_tips" : "الرجاء بدء اللعبة من المُشغّل.",
    "h5_download_repeat_get" : "لقد استلمت حزمة الهدايا هذه.",
    "h5_download_succ" : "يرجى تحميل المُشغّل أولاً.",
    "h5_download_repeat_role" : "الشخصية قد تم ربطها",
    "currentLoginAccount" : "الحساب الحالي",
    "fb_canvas_fullscreen" : "توسعة",
    "fb_canvas_website" : "الصفحة الرئيسية",
    "fb_canvas_like_share" : "مشاركة",
    "fb_canvas_service" : "الدعم",
    "fb_canvas_login_fail" : "فشل تسجيل الدخول",
    "fb_canvas_pay_return" : "لقد ألغيت المعاملة",
    "fb_canvas_root_tip" : "الرجاء تسجيل الدخول إلى Facebook للحصول على إذن أولاً",
    "h5_popup_title" : "طريقة الدفع",
    "h5_popup_submit" : "ادفع",
    "h5_popup_last_used" : "المستخدم مؤخرًا",
    "h5_popup_quit_tips" : "هل أنت متأكد من إلغاء الدفع",
    "h5_popup_quit_check" : "نعم",
    "h5_popup_quit_cancel" : "لا",
    "h5_popup_currency_sign" : "\$",
    "h5_popup_product_empty" : "لم يتم الحصول على معلومات المنتج حتى الآن. يرجى تحديث الصفحة",
    "h5_popup_server_empty" : "لا توجد قائمة الخوادم حتى الآن. يرجى تحديث الصفحة",
    "aboutRelevanceAccount" : "ربط الحساب",
    "selectLoginType" : "اختر طريقة تسجيلك للدخول",
    "touristDescription" : "If you already have an account, you can log in as a guest and then use the OTP (One-Time Password) feature in the user center to switch accounts. This feature requires the OTP functionality to be set up on your mobile device in the user center.",
    "touristSuggest" : "If you already have an account, you can log in as a guest and then tap the \"Switch Account\" option in the user center. From there, you can log in using a previously bound social media account.",
    "h5_tourist_remenber" : "تذكرني لمدة 14 يومًا",
    "account_czsm1" : "1、全てのゲームデータが新しい端末に引き継がれます。OSの異なる端末で引き継ぐことも可能です；",
    "account_czsm2" : "2、引き継ぐ時のパスワードを登録してください。",
    "account_czsm3" : "3、セキュリティ保護のため、",
    "account_wzfdmm" : "大文字と小文字を区別して、6-16文字のパスワードをご入力",
    "account_qzcsrmm" : "再度パスワードをご入力",
    "account_fxyjm" : "引き継ぎコード発行",
    "account_yjmsm1" : "1、タイトル画面にある「ユーザーセンター」をタップ、「切り替え」のページで引き継ぎを行ってください。",
    "account_yjmsm2" : "2、引き継ぎナンバーに使用期限はございません。",
    "account_yjmsm3" : "3、引き継ぎコードは一度しか使えません。再度引き継ぐことができます。",
    "account_yjmsm4" : "4、アカウントを保護するため、引き継ぎコードを他人に教えないようにしてください。",
    "account_fz" : "コピー",
    "account_cxfx" : "新規で発行する",
    "account_czsm4" : "アカウントを連携",
    "account_czsm5" : "してください。",
    "account_yjm" : "引き継ぎコード",
    "account_16wzzj" : "パスワードの長さは6～16文字にする",
    "account_qsrzqdyjmhmm" : "正しい引き継ぎコードとパスワードを入力してください。",
    "account_yj" : "引き継ぎ",
    "accoun_lcsrdmmbyz" : "パスワードの両回の入力は一致しない",
    "deleteaccount_step3_1" : "خلال 14 يومًا، إبطال الآن؟",
    "account_syyjm" : "1. 引き継ぎコードを使ってゲームデータがこの端末に引き継がれます。",
    "account_yjmznsyyc" : "2. 引き継ぎコードは一度しか使えず、再発行することができます。",
    "account_sryjm" : "引き継ぎコードを入力",
    "account_srmm" : "パスワードを入力",
    "h5_header_gift" : "حزمة",
    "h5_award_popup_type" : "مكافأة",
    "h5_award_popup_content" : "أداة",
    "h5_award_popup_code" : "رمز الحزمة",
    "h5_favour_gift_name" : "الحزمة المفضلة",
    "h5_download_gift_name" : "تحميل الحزمة",
    "h5_award_popup_exchange_way" : "",
    "h5_succ_get_gift" : "لقد حصلت على رمز مبادلة هدية!",
    "h5_exchange_info_title" : "استلام الهدية",
    "h5_exchange_info_1" : "",
    "h5_exchange_info_2" : "يمكنك استلام حزمة تنزيل واحدة فقط لكل حساب.",
    "h5_check_gift" : "معلومات الهدية",
    "account_delete_scdqzh" : "هل أنت متأكد أنك تريد حذف الحساب وبياناته؟",
    "account_delete_fwq" : "الخادم",
    "account_delete_zhm" : "الشخصية",
    "account_delete_jshflj" : "رابط استرجاع الشخصية",
    "account_delete_qzyzmdxx" : "(حساس لحالة الأحرف)",
    "account_delete_jtbcysxx" : "يُنصح بأخذ لقطة شاشة للمعلومات المذكورة أعلاه لاسترداد الحساب لاحقًا.",
    "deleteaccount_step3_2" : "بعد 14 يومًا ، سيتم حذف حسابك. لن تتمكن من استعادة وستفقد كافة معلوماته. \\\\n\\\\nيمكنك إلغاء حذف الحساب من خلال",
    "h5_guest_login" : "زائر",
    "h5_click_copy" : "نسخ",
    "questionnaire_btn" : "الاستطلاع عبر الاستبيان",
    "h5_header_store_text" : "الشحن",
    "h5_header_home_text" : "الصفحة الرئيسية",
    "h5_check_gift_list_text" : "معلومات الهدية",
    "yourServer" : "الخادم الخاص بك",
    "allServer" : "جميع الخوادم",
    "h5_header_screen" : "ملئ الشاشة",
    "h5_verticalTip" : "ينصح بالوضع الأفقي.",
    "h5_third_party_login_tips" : "If you want to log in using a social media account (such as Facebook, Google, Twitter, etc.), you can first log in as a guest and then bind your social media account in the user center.",
    "webStoreUidTitle" : "الـuid الخاص بالحساب",
    "webStoreUidTips" : "يرجى تأكيد المعلومات الخاصة بشخصيتك في اللعبة.",
    "webStoreUidGuide" : "كيف أحصل على الـUID؟",
    "webStoreUidInputt" : "أدخل uid",
    "feedbackTips" : "",
    "recentPlay" : "لعب مؤخرًا",
    "moreGames" : "المزيد",
    "previousSelect" : "السابق",
    "payAgainBtn" : "الشحن ثانية",
    "packageTypeName" : "حزمة",
    "coinTypeName" : "الشحن",
    "cardTypeName" : "البطاقة الشهرية",
    "orderNormal" : "ترتيب افتراضي",
    "orderPriceUp" : "ترتيب تصاعدي",
    "orderPriceDown" : "ترتيب تنازلي",
    "returnSelectRole" : "عودة",
    "jiamaInfo" : "مكافأة طريقة الدفع\nالعملات الإضافية = المبلغ المدفوع * سعر العملة * معدل المكافأة\n* ملاحظة: لن يتم احتساب العملات الإضافية عن طريق فعاليات الشحن أو خبرة VIP.\n* يتم حساب مبلغ الدفع بالدولار الأمريكي بالنسبة للألعاب التي يتم إطلاقها عالميًا. يرجى الاتصال بخدمة العملاء إذا كان لديك أي تساؤلات.",
    "lastSelectTag" : "اُستُخدِم سابقًا",
    "onestore_subscribe_manage" : "إدارة",
    "onestore_subscribe_entrance" : "اشتراك OneStore",
    "onestore_subscribe_has_expire" : "انتهت الصلاحية",
    "onestore_subscribe_expire_time" : "ينتهي في \${day}/\${month}/\${year}",
    "onestore_subscribe_privacy" : "بخصوص الاشتراك والخصوصية",
    "onestore_subscribe_cancel_subscribe" : "إلغاء الاشتراك",
    "onestore_subscribe_info_title" : "معلومات الاشتراك",
    "onestore_subscribe_option_title" : "الإعدادات",
    "onestore_subscribe_do_not_subscribe" : "الشخصية الحالية لم تقم بأية اشتراكات",
    "onestore_subscribe_get_role_fail" : "فشل الاشتراك. يرجى فتح تلك الصفحة ثانية داخل اللعبة",
    "onestore_subscribe_later" : "لاحقًا",
    "onestore_subscribe_confirm" : "تأكيد",
    "onestore_subscribe_confirm_cancel" : "تأكيد الإلغاء",
    "onestore_subscribe_popup_tip" : "إذا ألغيت الآن، ستستمر إمكانية الوصول إلى اشتراكك حتى \${day}/\${month}/\${year}.",
    "onestore_subscribe_detail_tip" : "الأداة المشترك بها سيتم تجديدها في \${day}/\${month}/\${year}، (السعر: \${prices}/شهر). يمكن إلغاء الاشتراك قبل تاريخ انتهائه بـ1 يوم.",
    "onestore_subscribe_expired_tip" : "بخصوص الاشتراكات المنتهية، يرجى إعادة تجديدها من المتجر داخل اللعبة",
    "onestore_subscribe_goon_sub" : "سيتم التجديد في \${day}/\${month}/\${year}",
    "onestore_subscribe_has_cancel_tip1" : "تم إلغاء الاشتراك، ومع ذلك سيمكن استخدامه حتى \${day}/\${month}/\${year}.",
    "onestore_subscribe_has_cancel_tip2" : "إذا كنت ترغب في الاشتراك مرة أخرى. يرجى القيام بذلك في المركز التجاري / المتجر داخل اللعبة.",
    "onestore_subscribe_cancel_fail" : "فشل إلغاء الاشتراك. الرجاء معاودة المحاولة في وقت لاحق.",
    "onestore_subscribe_cancel_fail_title" : "إلغاء الاشتراك",
    "apple_deleteaccount" : "حذف الحساب",
    "apple_deleteaccount_title" : "طلب حذف الحساب",
    "apple_deleteaccount_step1_1" : "يرجى قراءة البنود والشروط التالية بعناية:",
    "apple_deleteaccount_step1_2" : "سيتم تجميد حسابك لمدة 14 يومًا منذ حذف الحساب.",
    "apple_deleteaccount_step1_3" : "سيتم <span class = \"highlight\"> حذف حسابك نهائيًا </ span> إذا لم تقم بإلغاء عملية الحذف خلال 14 يومًا. عند حذف حسابك، لن تتمكن من استخدامه لتسجيل الدخول إلى اللعبة، وسيتم حذف جميع المعلومات الموجودة به.",
    "apple_deleteaccount_step1_4" : "إذا كنت ترغب في إلغاء ربط حسابات مواقع التواصل الاجتماعي بالحساب، فيرجى الاتصال بفريق خدمة العملاء للقيام بعملية إلغاء الربط قبل حذف حسابك. خلاف ذلك، وفي حالة حذف حسابك بنجاح، لن تتمكن من استخدام حسابات مواقع التواصل الاجتماعي المرتبطة لتسجيل الدخول إلى اللعبة.",
    "apple_deleteaccount_step1_5" : "يرجى التأكد من التخلص من الممتلكات الافتراضية الخاصة بك في اللعبة بشكل صحيح قبل التقدم بطلب حذف حسابك. <span class = \"highlight\"> إذا كنت ترغب في التقدم بطلب لاسترداد الأموال، فالرجاء أيضًا القيام بذلك قبل حذف حسابك </ span> .",
    "apple_deleteaccount_step1_6" : "يمكنك إلغاء الحذف في غضون 14 يومًا من خلال الرابط أدناه، يرجى حفظ الرابط مسبقًا:",
    "apple_deleteaccount_step2_1" : "هل تخلصت بشكل صحيح من الممتلكات الافتراضية في اللعبة؟ إذا لم تقم بذلك، يرجى الاتصال بفريق خدمة العملاء بخصوص هذه المسألة قبل إرسال طلب حذف الحساب.",
    "apple_deleteaccount_step2_2" : "يرجى حفظ معلومات الخادم والشخصية، تلك المعلومات ستكون مطلوبة لاستعادة حسابك.",
    "apple_deleteaccount_step2_3" : "الرجاء كتابة \"حذف\" لاستكمال الحذف",
    "apple_deleteaccount_step3_1" : "تم تقديم طلب حذف حسابك. الحساب التالي مجمد الآن:",
    "apple_deleteaccount_step3_2" : "سنحذف حسابك نهائيًا بعد 14 يومًا إذا لم يكن هناك طلب آخر لإلغاء الحذف منك.",
    "apple_deleteaccount_step3_3" : "يمكنك زيارة الرابط التالي لإلغاء الحذف خلال فترة 14 يومًا",
    "apple_deleteaccount_step4_1" : "لقد قمت بحذف حسابك القديم. الرجاء تسجيل الدخول بحساب جديد في المرة القادمة.",
    "apple_deleteaccount_agree" : "لقد قرأت ووافقت على الشروط والأحكام أعلاه",
    "apple_deleteaccount_server" : "الخادم",
    "apple_deleteaccount_roleName" : "الشخصية",
    "copyLink" : "نسخ الرابط",
    "copyTextAndImg" : "يرجى نسخ الرابط وحفظه أو أخذ لقطة للشاشة",
    "copyLinkAndRoleInfo" : "انسخ الرابط واسم الشخصية",
    "hasCopy" : "تم النسخ إلى الحافظة",
    "quickcard_tips" : "تم تشفير معلومات بطاقتك الائتمانية وتأمينها بواسطة Worldpay. المعلومات المعروضة هي فقط لتوفير تجربة أفضل.",
    "quickcard_use_new_card" : "بطاقة ائتمانية جديدة",
    "edit" : "تعديل",
    "save" : "حفظ",
    "quickcard_confirm_delete" : "حذف؟",
    "quickcard_popup_tip" : "إذا كنت تريد استخدام هذه البطاقة مرة أخرى بعد حذفها، الرجاء اختيار \"بطاقة ائتمانية جديدة\".",
    "quickcard_result_tip_one" : "إذا اخترت حفظ رقم بطاقتك في الصفحة السابقة، فسنجمع بيانات بطاقتك (**** **** **** 1234) في إصدار مشفر.",
    "quickcard_result_tip_two" : "سنقوم بتخزين التفاصيل المشفرة فقط من أجل راحتك، ولن يتعين عليك إدخال أرقام البطاقة في عملية الشراء المقبلة.",
    "quickcard_learn_more" : "معرفة المزيد 》",
    "quickcard_info_title" : "بيانات أوراق الاعتماد المخزنة",
    "quickcard_info_tip_one" : "لحماية أمان بيانات العملاء بشكل أفضل، تقدم Visa و Mastercard تعريفات جديدة لـ \"بيانات الاعتماد المخزنة\" هذه ، وقواعد جديدة لبيانات الاعتماد المخزنة والمعاملات التي يقوم بها التاجر.",
    "quickcard_info_tip_two" : "عند إجراء عملية شراء على موقعنا، نقوم بجمع بيانات بطاقتك (1234 **** **** 1234) في إصدار مشفر. سنحتفظ بالتفاصيل المشفرة لمدة 4 سنوات وسنقوم بتحديث الاتفاقية وسياسة الخصوصية على موقعنا في حالة وجود أي تغييرات. نقوم بتخزين التفاصيل المشفرة فقط من أجل راحتك، حيث لن يتعين عليك إدخال أرقام البطاقة في عملية الشراء المقبلة.",
    "search_product" : "العثور على أداة",
    "search_price" : "العثور على السعر",
    "price" : "السعر",
    "product_no_found" : "لم يتم العثور على أدوات",
    "price_no_found" : "لم يتم العثور على السعر",
    "search_no_found" : "لم يتم العثور على أدوات / أسعار",
    "product" : "اسم الأداة",
    "store_tag_hot" : "HOT",
    "store_tag_discount" : "Discount",
    "store_tag_double" : "Double",
    "store_tag_treble" : "Treble",
    "store_tag_sale" : "SALE",
    "store_tag_top_seller" : "TOP SELLER",
    "store_tag_off_10" : "10%OFF",
    "store_tag_off_20" : "20%OFF",
    "store_tag_off_30" : "30%OFF",
    "store_tag_off_40" : "40%OFF",
    "store_tag_off_50" : "50%OFF",
    "store_tag_off_60" : "60%OFF",
    "store_tag_off_70" : "70%OFF",
    "store_tag_off_80" : "80%OFF",
    "store_tag_off_90" : "90%OFF",
    "store_tag_event" : "Event",
    "store_tag_daily" : "Daily",
    "store_tag_weekly" : "Weekly",
    "store_tag_monthly" : "Monthly",
    "subscriptionTypeName" : "subscription",
    "useDoubleSend" : "Use Box Multiplier?",
    "doubleSendInfo" : "Since you used a Box Multiplier, some of the items you purchased were doubled (as shown at the bottom)!",
    "storeRoleTitle" : "Please Choose Character",
    "storeSocialLogin" : "Log in with SNS accounts",
    "storeAccountIdLogin" : "Log in with account ID",
    "storeInputId" : "Enter account ID",
    "storeSearch" : "Search",
    "storeSelectProductTitle" : "Choose Items",
    "storeInputNameSearch" : "Enter item name and search",
    "storeInputPriceSearch" : "Enter item price and search",
    "storeNoFindProduct" : "Item not found. Please try again.",
    "storePriceUp" : "Price↑",
    "storePriceDown" : "Price↓",
    "storeLookDetail" : "Details",
    "storeChangeProduct" : "Change Item",
    "storeWelcome" : "Welcome",
    "storeLookMore" : "More",
    "storeHasSelect" : "Item Selected",
    "storeTotal" : "Total",
    "storeExtra" : "Bonus",
    "storeProductDetail" : "Details",
    "storeUidGuideStep1" : "Tap Settings > More > Account",
    "storeUidGuideStep2" : "Enter the account ID when topping up",
    "storeSelectAndLook" : "Please select your character first",
    "storeSwitchWay" : "Switch Login Method",
    "type1" : "Daily Sale",
    "type2" : "Hero",
    "type3" : "Battle Gear",
    "type4" : "",
    "type5" : "Chip",
    "type6" : "Nova",
    "type7" : "Resource",
    "type8" : "Build Speedup",
    "type9" : "Rare Items",
    "type10" : "Alliance",
    "type11" : "Diamond",
    "type12" : "Module",
    "type13" : "Cube",
    "type14" : "",
    "type15" : "Nanoweapon",
    "type16" : "Grand Prize",
    "type17" : "",
    "type9999" : "Limited Offer",
    "type10000" : "Gift Center",
    "type10001" : "Holiday Events",
    "typeother" : "عناصر أخرى",
    "switchChar" : "Switch Character",
    "howToFindUid" : "How to find my account ID?",
    "choosePayWay" : "Choose a Payment Method",
    "new_apple_deleteaccount_stepsub_title" : "إلغاء التجديد التلقائي",
    "new_apple_deleteaccount_stepsub_1" : "تم العثور على اشتراك يُجدد تلقائيًا تحت حسابك. يُنصح بإلغاء التجديد التلقائي قبل حذف حسابك تجنبًا لأي عمليات شراء غير مقصودة.",
    "new_apple_deleteaccount_stepsub_2" : "إلغاء التجديد التلقائي",
    "new_apple_deleteaccount_stepsub_later" : "لاحقًا",
    "new_apple_deleteaccount_stepsub_now" : "الآن",
    "new_apple_deleteaccount_title" : "طلب حذف الحساب",
    "new_apple_deleteaccount_step1_1" : "يرجى قراءة الأحكام والشروط التالية بعناية:",
    "new_apple_deleteaccount_step1_2" : "سيتم حذف حسابك للأبد بعد القيام بعملية الحذف. لن تتمكن من استخدامه لتسجيل الدخول إلى اللعبة.\nجميع معلومات حسابك المحذوفة لن تكون قابلة لإعادة الاسترجاع.",
    "new_apple_deleteaccount_step1_3" : "إذا كنت ترغب في فك ارتباط حساب التواصل الاجتماعي المرتبط بحسابك، فيرجى التواصل مع خدمة العملاء لإتمام فك الارتباط قبل القيام بالحذف. وإلا لن تتمكن من استخدام حساب التواصل الاجتماعي المرتبط لتسجيل الدخول إلى اللعبة بعد إتمام حذف الحساب. يرجى التأكد من القيام بالتخلص من ممتلكاتك الرقمية في اللعبة قبل التقدم بطلب حذف الحساب.",
    "new_apple_deleteaccount_step1_4" : "إذا كنت ترغب في القيام بعملية استرداد الأموال، فيرجى القيام بذلك قبل حذف الحساب.يرجى التأكد من القيام بالتخلص من ممتلكاتك الرقمية في اللعبة قبل حذف الحساب.",
    "new_apple_deleteaccount_step2_1" : "هل تخلصت بشكل سليم من ممتلكاتك الافتراضية باللعبة؟ إذا لم تقم بذلك، فيرجى التواصل مع فريق خدمة العملاء بخصوص هذا الأمر قبل تسليم طلب حذف الحساب.",
    "new_apple_deleteaccount_step2_2" : "اضغط على الزر «حذف» لإكمال الحذف. لن يمكن التراجع في حذف الحساب بمجرد الشروع فيه.",
    "new_apple_deleteaccount_step2_3" : "Please key in \"Delete\" to complete the deletion",
    "new_apple_deleteaccount_step3_1" : "تم تسليم طلبك لحذف الحساب. الحساب التالي تم حذفه:",
    "new_apple_deleteaccount_step3_2" : "يرجى إنشاء حساب جديد إذا كنت ترغب في تسجيل الدخول إلى اللعبة مرة ثانية.",
    "new_apple_deleteaccount_step4_1" : "لقد حذفت حسابك. يرجى تسجيل الدخول بحساب جديد في المرة القادمة.",
    "currencyTypeName" : "عملة",
    "has_select_product" : "عناصرك:",
    "n_product" : "\${n} عنصر",
    "look_detail_product" : "عرض الكل",
    "limit_buy_product" : "حد الشراء لهذا العنصر: \${n}",
    "limit_order" : "يمكنك شراء \${n} عنصر فقط كحد أقصى في كل مرة.",
    "limit_order_remove_tip" : "لقد وصلت إلى حد الشراء لبعض العناصر في سلة التسوق هذه، هل تريد إزالتها؟",
    "paytype_limit" : "لا يمكن استخدام طريقة الدفع هذه لشراء بعض العناصر الخاصة بك. الرجاء اختيار طريقة دفع أخرى أو محاولة شرائها بشكل منفصل.",
    "check_remove_cart" : "إزالة من عربة التسوق؟",
    "remove_cart" : "إزالة",
    "confirm_product" : "تأكيد",
    "select_paytype" : "اختر طريقة الدفع",
    "cart_is_empty_tip" : "لم يتم العثور على عناصر، رجاء تحديد عنصر أولًا.",
    "thirty_tip" : "إذ لم تصلك العناصر التي اشتريتها خلال 30 دقيقة، فيرجى الاتصال بخدمة العملاء لدينا.",
    "total_n_product" : "المجموع  \${n} عنصر",
    "look_detail_of_cart" : "عرض الكل",
    "order_detail" : "قائمة العناصر",
    "total_detail" : "الكمية:",
    "add_to_cart" : "أضف إلى السلة",
    "back_to_select" : "عودة",
    "fail_and_later" : "Item info error. Please try again later.",
    "nextStep" : "تأكيد",
    "pnsGameName" : "Puzzles & Survival",
    "enterOfficial" : "الذهاب إلى الموقع الرسمي",
    "visitorLogin" : "تسجيل الدخول كزائر",
    "tokenLogin" : "OTP",
    "fbLogin" : "تسجيل الدخول عبر Facebook",
    "googleLogin" : "تسجيل الدخول عبر Google",
    "twitterLogin" : "تسجيل الدخول عبر Twitter",
    "vkLogin" : "تسجيل الدخول VK",
    "agreementTextStart" : "تسجيل الدخول إلى اللعبة يعبر عن قراءتك وموافقتك تمامًا على  شروط الحساب  و سياسة الخصوصية",
    "userCenter" : "مركز المستخدم",
    "welcomeBack" : "مرحبًا بعودتك",
    "continueGame" : "استكمال اللعب",
    "officialPay" : "مركز الشحن الرسمي",
    "changeAccount" : "تبديل الحساب",
    "back" : "عودة",
    "tokenKey" : "OTP",
    "inputUid" : "يرجى إدخال الـUID",
    "inputToken" : "يرجى إدخال الـOTP",
    "inputCkCode" : "يرجى إدخال كود التحقق",
    "enterGame" : "الدخول إلى اللعبة",
    "tokenTip" : "يرجى استخدام رمز OTP لحماية حسابك",
    "howToGetToken" : "كيف أحصل على رمز OTP الخاص بي؟",
    "getStep1" : "الخطوة 1: اضغط على الإعدادات - الحساب - مركز المستخدم",
    "getStep2" : "الخطوة 2: اضغط على OTP",
    "getStep3" : "الخطوة 3: قم بالنسخ ثم أدخل الـUID الخاص بك وأيضًا الـOTP",
    "copy" : "نسخ",
    "lastRefresh" : "التحديث التالي:",
    "second" : "s",
    "immediatelyRefresh" : "حدّث فورًا",
    "frequently" : "عملية شديدة التكرار، يرجى الانتظار قليلاً ثم إعادة المحاولة",
    "loginFail" : "فشل تسجيل الدخول، كود التحقق غير صحيح",
    "tokenIntro" : "شرح استخدام الـOTP:",
    "tokenIntro1" : "1. تنتهي صلاحية الـOTP (كلمة المرور ذات الاستخدام الواحد) خلال 120 ثانية. ويمكن استخدامها للحفاظ على حسابك آمنًا.",
    "tokenIntro2" : "2. لن يطلب فريق  الـOTP الخاص بك. يرجى عدم مشاركته أو إعطائه لأي شخص.",
    "nextStep1" : "تأكيد",
    "couponCanUse" : "قابل للاستخدام",
    "couponCanNotUse" : "غير قابل للاستخدام",
    "couponHasNoCoupon" : "لا توجد كوبونات",
    "couponUseTip" : "استخدم كوبون واحد لكل طلب",
    "couponValidTime" : "الصلاحية",
    "couponFuilCanUse" : "يمكن استخدامه مع الطلبات الأكثر من \${price} \${currency}",
    "couponNoLimit" : "لا يوجد حدود للاستخدام",
    "couponAllProductCanUse" : "جميع العناصر",
    "couponPartProductCanUse" : "عناصر محددة",
    "couponPartPaytypeCanUse" : "وسائل دفع محددة",
    "couponOnlyCoinCanUse" : "حصري للعملات داخل اللعبة",
    "couponOnlyDiamondCanUse" : "حصري للماس",
    "couponOnlyPackageCanUse" : "حصري للحزم",
    "couponOnlySubCanUse" : "حصري للاشتراكات",
    "couponOnlyDaibiCanUse" : "حصري للرموز",
    "couponMaxDiscount" : "خصم حتى \${price} \${currency}",
    "couponHasUsed" : "مستخدم",
    "couponReductionType" : "خصم",
    "couponDiscountType" : "تخفيض",
    "couponUseNow" : "استخدام",
    "couponHasNoSelect" : "لم يتم استخدام كوبون",
    "couponHasSelectQuan" : "تم تخفيض",
    "couponSubmitTip" : "سيتم استخدام الكوبونات",
    "couponCanUseQuan" : "الكوبونات",
    "couponOrderTotal" : "الإجمالي",
    "couponHasDiscount" : "تم تخفيض",
    "couponPayTotal" : "الدفع",
    "couponCancel" : "إلغاء",
    "couponConfirm" : "تأكيد",
    "uidLoginName" : "تسجيل الدخول عبر OTP",
    "uidToken" : "OTP",
    "uidInputUid" : "يرجى إدخال الـUID",
    "uidInputToken" : "يرجى إدخال الـOTP",
    "uidInputCode" : "يرجى إدخال كود التحقق",
    "uidTipTitle" : "يرجى استخدام رمز OTP لحماية حسابك",
    "uidTipHowToGet" : "كيف أحصل على رمز OTP الخاص بي؟",
    "uidTipStep1" : "الخطوة 1: اضغط على الإعدادات - الحساب - مركز المستخدم",
    "uidTipStep2" : "الخطوة 2: اضغط على OTP",
    "uidTipstep3" : "الخطوة 3: قم بالنسخ ثم أدخل الـUID الخاص بك وأيضًا الـOTP",
    "uidTipIntro1" : "1. تنتهي صلاحية الـOTP (كلمة المرور ذات الاستخدام الواحد) خلال 60 ثانية. ويمكن استخدامها للحفاظ على حسابك آمنًا.",
    "uidTipIntro2" : "2. لن يطلب فريق  الـOTP الخاص بك. يرجى عدم مشاركته أو إعطائه لأي شخص.",
    "couponMyQuan" : "الكوبونات",
    "couponSelectPaytypeTip" : "اختر وسيلة الدفع لعرض معلومات التخفيض",
    "couponSelectCouponTip" : "اختر الكوبونات لعرض السعر المُخفض",
    "couponValidQuanTip" : "(يمكن استخدام \${num} كوبونات)",
    "couponLookCart" : "العربة",
    "couponUnfoldCart" : "إخفاء",
    "couponCoupon" : "كوبون",
    "couponNoUse" : "غير مستخدم",
    "couponSelect" : "اختر كوبون",
    "couponSureUse" : "استخدام",
    "couponReturn" : "عودة",
    "couponInvalidTime" : "تنتهي الصلاحية في",
    "couponBuyNow" : "اشتري الآن",
    "couponAllType" : "all",
    "ztmslgType1" : "Daily Sale",
    "ztmslgType2" : "Hero",
    "ztmslgType3" : "Battle Gear",
    "ztmslgType4" : "",
    "ztmslgType5" : "Chip",
    "ztmslgType6" : "Nova",
    "ztmslgType7" : "Resource",
    "ztmslgType8" : "Build Speedup",
    "ztmslgType9" : "Rare Items",
    "ztmslgType10" : "Alliance",
    "ztmslgType11" : "Diamond",
    "ztmslgType12" : "Module",
    "ztmslgType13" : "Cube",
    "ztmslgType14" : "",
    "ztmslgType15" : "Nanoweapon",
    "ztmslgType16" : "Grand Prize",
    "ztmslgType17" : "القلب البلوري",
    "ztmslgType9999" : "Limited Offer",
    "ztmslgType10000" : "Gift Center",
    "ztmslgType10001" : "Holiday Events",
    "ztmslgTypeother" : "Other",
    "antslgType1" : "Daily Sale",
    "antslgType2" : "Specialized Ant",
    "antslgType3" : "Gear",
    "antslgType5" : "Gene",
    "antslgType6" : "Snail",
    "antslgType7" : "Resources",
    "antslgType8" : "Build & Research",
    "antslgType9" : "Rare Items",
    "antslgType10" : "Alliance",
    "antslgType11" : "Diamond",
    "antslgType12" : "Cell",
    "antslgType13" : "Totem",
    "antslgType9999" : "Limited Offer",
    "antslgTypeother" : "other",
    "typeall" : "جميع المنتجات",
    "vipHead" : "نقاط VIP",
    "vipHead213": "العضوية المميزة",
    "vipTitle" : "حدث نقاط VIP",
    "nowLevel" : "مستواك:",
    "myVipScore" : "نقاطك:",
    "nextLevelNeed" : "(احصل على \${num} نقاط أكثر لتحصل على VIP \${level})",
    "ruleTitle" : "القواعد:",
    "ztmslgVipRule1" : "1. يبدأ الحدث في 00:00 (UTC) 2022/09/22",
    "ztmslgVipRule2" : "2. الألعاب المتاحة:  Puzzles & Survival",
    "ztmslgVipRule3" : "كل نوع من هدايا الحدث يمكن استلامه مرة واحدة فقط.",
    "ztmslgVipRule4" : "3. نشاط \"سجل دخولك واربح القسيمة\": قم بتسجيل الدخول إلى صفحة الشحن لأول مرة واحصل على قسيمة تخفيض 15٪.",
    "ztmslgVipRule5" : "4. حدث نقاط VIP: اشترِ عنصر عبر صفحتنا الرسمية لكسب النقاط والحصول على كوبونات المستوى والكوبونات الأسبوعية.",
    "ztmslgVipRule6" : "5. قد تختلف النقاط التي قد تكسبها وفقًا للعملة التي تستخدمها. لمزيد من التفاصيل، يرجى التحقق من الرابط في الأسفل.",
    "ztmslgVipRule7" : "6. إذا تم استخدام كوبون تخفيض عند تنفيذ الطلب، فسيتم احتساب النقاط وفقًا للمبلغ الفعلي المدفوع.",
    "ztmslgVipRule8" : "7. ستنتهي صلاحية النقاط التي حصلت عليها خلال 365 يومًا. قد يؤثر هذا على مستوى VIP الخاص بك.",
    "ztmslgVipRule9" : "8. ستحصل على الفور على كوبون نظرًا للوصول إلى مستوى VIP لأول مرة. يمكن استلام الكوبون الأسبوعي الساعة 00:00 (UTC+0) كل يوم سبت.",
    "ztmslgVipRule10" : "9. سوف تحتاج إلى تسجيل الدخول لاستلام الكوبون الأسبوعي. لا تفوت الفرصة!",
    "ztmslgVipRule11" : "10. ستكون عملة الكوبون هي عملة آخر طلب قمت به. يرجى الاتصال بخدمة العملاء إذا كنت ترغب في تغيير العملة التي تستخدمها.",
    "ztmslgVipRule12" : "11. راجع الجدول أدناه للحصول على مزيد من التفاصيل حول مستويات وكوبونات VIP.",
    "ztmslgVipRule13" : "12. في حالة وجود أي نزاع، يكون لفريق دعم Puzzles & Survival  التقدير المنفرد والنهائي لتفسير هذه الشروط والأحكام.",
    "vipLevel" : "مستوى VIP",
    "vipCondition" : "النقاط المطلوبة",
    "firstSend" : "هدايا الوصول الأول",
    "weeklySend" : "الكوبون الأسبوعي",
    "lastAllCoupon" : "كوبونات المستوى السابق",
    "besides" : "جدول العملة/النقاط:",
    "couponRatio" : "معدل العملة/النقاط",
    "backToPay" : "عودة",
    "quanGift" : "كوبون",
    "quanGiftTips" : "لديك كوبون (كوبونات) يمكن استلامها!",
    "antslgVipRule1" : "بسبب الخصائص الجديدة، سيتم إيقاف نشاط \"نقاط VIP\" السابق قريبًا.",
    "antslgVipRule2" : "يرجى استخدام القسائم التي تم الحصول عليها من نشاط \"نقاط VIP\" السابق في الوقت المناسب لتجنب تجاوز فترة صلاحية القسيمة.",
    "antslgVipRule3" : "وقت الإيقاف: 28-09-2024 00:00:00 (التوقيت العالمي)",
    "antslgVipRule4" : "بعد أن يتم وقف الحدث، يمكنك الذهاب إلى مركز VIP لتجربة المزيد من الصلاحيات:",
    "antslgVipRule5" : "أكمل المهام لتربح النقاط، والتي يمكن استبدالها بقسائم وعناصر باللعبة ومكافآت أخرى! هناك أيضًا الصلاحيات الحصرية للـ VIP وسحب النقاط وأنشطة المزايا الأخرى.",
    "antslgVipRule6" : "آتٍ قريبًا",
    "dzgVipRule0" : "1. يبدأ الحدث في 00:00 (UTC) 2022/09/27",
    "dzgVipRule1" : "1. الألعاب المتاحة:  \${gameName}",
    "dzgVipRule2" : "كل نوع من هدايا الحدث يمكن استلامه مرة واحدة فقط.",
    "dzgVipRule3" : "2. نشاط \"سجل دخولك واربح القسيمة\": قم بتسجيل الدخول إلى صفحة الشحن لأول مرة واحصل على قسيمة تخفيض 15٪.",
    "dzgVipRule4" : "3. حدث نقاط VIP: اشترِ عنصر عبر صفحتنا الرسمية لكسب النقاط والحصول على كوبونات المستوى والكوبونات الأسبوعية.",
    "dzgVipRule5" : "4. قد تختلف النقاط التي قد تكسبها وفقًا للعملة التي تستخدمها. لمزيد من التفاصيل، يرجى التحقق من الرابط في الأسفل.",
    "dzgVipRule6" : "5. إذا تم استخدام كوبون تخفيض عند تنفيذ الطلب، فسيتم احتساب النقاط وفقًا للمبلغ الفعلي المدفوع.",
    "dzgVipRule7" : "6. ستنتهي صلاحية النقاط التي حصلت عليها خلال 365 يومًا. قد يؤثر هذا على مستوى VIP الخاص بك.",
    "dzgVipRule8" : "7. ستحصل على الفور على كوبون نظرًا للوصول إلى مستوى VIP لأول مرة. يمكن استلام الكوبون الأسبوعي الساعة 00:00 (UTC+0) كل يوم سبت.",
    "dzgVipRule9" : "8. سوف تحتاج إلى تسجيل الدخول لاستلام الكوبون الأسبوعي. لا تفوت الفرصة!",
    "dzgVipRule10" : "9. ستكون عملة الكوبون هي عملة آخر طلب قمت به. يرجى الاتصال بخدمة العملاء إذا كنت ترغب في تغيير العملة التي تستخدمها.",
    "dzgVipRule11" : "10. راجع الجدول أدناه للحصول على مزيد من التفاصيل حول مستويات وكوبونات VIP.",
    "dzgVipRule12" : "11. في حالة وجود أي نزاع، يكون لفريق دعم \${gameName} التقدير المنفرد والنهائي لتفسير هذه الشروط والأحكام.",
    "213dzgVipRule1" : "بسبب الخصائص الجديدة، سيتم إيقاف نشاط \"نقاط VIP\" السابق قريبًا.",
    "213dzgVipRule2" : "يرجى استخدام القسائم التي تم الحصول عليها من نشاط \"نقاط VIP\" السابق في الوقت المناسب لتجنب تجاوز فترة صلاحية القسيمة.",
    "213dzgVipRule3" : "وقت الإيقاف: 19-08-2024 08:00:00 (التوقيت العالمي)",
    "213dzgVipRule4" : "بعد أن يتم وقف الحدث، يمكنك الذهاب إلى مركز VIP لتجربة المزيد من الصلاحيات:",
    "213dzgVipRule5" : "أكمل المهام لتربح النقاط، والتي يمكن استبدالها بقسائم وعناصر باللعبة ومكافآت أخرى! هناك أيضًا الصلاحيات الحصرية للـ VIP وسحب النقاط وأنشطة المزايا الأخرى.",
    "213dzgVipRule6" : "آتٍ قريبًا",
    "getReward" : "Exclusive avatar frames",
    "unbindEntry" : "ربط/فك ربط الحساب",
    "unbindApply" : "فك الربط",
    "unbindConfirmTitle" : "متأكد من فك ربط الحساب؟",
    "unbindConfirmTip" : "قد يؤدي فك ربط الحساب إلى فقدان التقدم باللعبة.",
    "unbindConfirm" : "تأكيد فك الربط",
    "unbindExit" : "خروج",
    "unbindSucc" : "تم فك ربط الحساب",
    "unbindFail" : "فشل فك ربط الحساب. يرجى التواصل مع خدمة العملاء.",
    "unbindServiceTitle" : "يرجى التقدم بطلب لفك الربط يدويًا.",
    "unbindContact" : "خدمة العملاء.",
    "unbindServiceTip" : "لم تستوفِ شروط الفك التلقائي، يرجى التواصل مع خدمة العملاء.",
    "antslgType15" : "Legacy",
    "shareEventTitle" : "قم بدعوة أصدقاءك</br>وشاركوا الهدايا",
    "shareRule" : "القواعد",
    "awardBag" : "حقيبة مكافآتي",
    "initiatorText" : "انا مرسل الدعوة",
    "inviteeText" : "انا متلقي الدعوة",
    "createCode" : "إنشاء رقم دعوة",
    "createCodeTip" : "اضغط لتوليد رقم الدعوة الحصري",
    "createLinkTip" : "اضغط لتوليد رابط الدعوة الحصري",
    "copyText" : "نسخ",
    "shareCode" : "مشاركة رقم الدعوة",
    "twShare" : "",
    "fbShare" : "",
    "dcShare" : "",
    "seeAward" : "عرض المكافآت",
    "seeAwardTip" : "توجه إلى<span class=\"see-light\"> \"نقاط VIP</span>\" - \"<span class=\"see-light\">قسائم التخفيض\" </span>للعرض والاستخدام",
    "inviteReward" : "مكافآت الدعوة",
    "inviteRewardTip" : "لا يتم إعادة تعيين مستوى شحن متلقي الدعوة",
    "overweightReward" : "المكافآت الإضافية",
    "resetTip" : "يعاد التعيين في الساعة 00:00 في اليوم الأخير من كل شهر",
    "rewardText1" : "وصول الشحن التراكمي لمتلقي الدعوة إلى 9.99 دولار",
    "rewardText2" : "وصول الشحن التراكمي لمتلقي الدعوة إلى 49.99 دولار",
    "rewardText3" : "وصول الشحن التراكمي لمتلقي الدعوة إلى 99.99 دولار",
    "rewardText4" : "ستحصل على قسيمة تخفيض بقيمة 12% كل مرة كل مرة تدعو 5 أشخاص!",
    "rewardText5" : "ستحصل على قسيمة تخفيض بقيمة 15% عند وصول إجمالي شحن الأشخاص المدعوين إلى 1000 دولار!",
    "invitationList" : "دعواتي",
    "refresh" : "تحديث",
    "invitedTotal" : "تم دعوة: \${total}",
    "storedTotal" : "إجمالي الشحن التراكمي: \${total} USD",
    "people" : "",
    "invitedPeople" : "المدعوين",
    "invitedTime" : "وقت تلقي الدعوة",
    "got" : "اكتمل",
    "get" : "غير مكتمل",
    "overlay" : "قابل للتراكم",
    "couponText" : "قسيمة التخفيض",
    "personalReward" : "مكافآت الشحن الشخصي",
    "personalRewardText1" : "وصول الشحن التراكمي الشخصي إلى 9.99 دولار",
    "personalRewardText2" : "وصول الشحن التراكمي الشخصي إلى 49.99 دولار",
    "personalRewardText3" : "وصول الشحن التراكمي الشخصي إلى 99.99 دولار",
    "inputCode" : "أدخل رقم الدعوة",
    "bindCode" : "ربط رقم الدعوة",
    "bindSucc" : "تم الربط",
    "codeTip1" : "رقم الدعوة غير موجود، يرجى إعادة الإدخال",
    "codeTip2" : "تم ربط رقم الدعوة",
    "copySucc" : "تم النسخ",
    "awardName" : "اسم المكافأة",
    "getTime" : "وقت الحصول عليها",
    "getCondition" : "شروط الحصول عليها",
    "couponText1" : "قسيمة تخفيض 6%",
    "couponText2" : "قسيمة تخفيض 8%",
    "couponText3" : "قسيمة تخفيض 10%",
    "couponText4" : "قسيمة تخفيض 12%",
    "couponText5" : "قسيمة تخفيض 15%",
    "ruleText1" : "1. وقت الحدث: 2022/11/25 من الساعة 00:00（UTC)",
    "ruleText2" : "2. شارك في لعبة: Puzzles & Survival",
    "ruleText3" : "3. حدث \"مشاركة الشحن الرسمي\": شارك وادعُ أصدقاءك لاستخدام الصفحة الرسمية للشحن، واحصل على مكافآت رائعة عند قيامهم بالشحن إلى المستويات المحددة.",
    "ruleText4" : "4. \"المكافآت الشهرية للمشاركة إلى الطرف الثالث\": قم بالوصول إلى أهداف المشاركة الشهرية وسيمكنك الحصول على المكافآت المقابلة، يتم تحديث المكافآت كل شهر.",
    "ruleText5" : "5. تتطلب المكافآت الشهرية دفعة واحدة على الأقل من عمليات الدفع الناجحة على موقع الطرف الثالث بواسطة لاعبين جدد قمت بدعوتهم.",
    "ruleText6" : "6. تتم إعادة تعيين المكافآت الشهرية في اليوم الأول من كل شهر. يؤدي هذا أيضًا إلى إعادة تعيين أي تقدم من الشهر السابق.",
    "ruleText7" : "7. يجب المطالبة بالقسيمة التي تم الحصول عليها عن طريق تسجيل الدخول إلى صفحة الشحن الخاصة بالطرف الثالث. لن تتلقى قسيمة أخرى إذا انتهت صلاحيتها.",
    "ruleText8" : "8. تستخدم القسيمة نفس العملة التي استخدمتها في عمليات الشحن الناجحة السابقة.",
    "ruleText9" : "9. لا يمكن لكل لاعب من كلا اللاعبين ربط رقم الدعوة الخاص بالطرف المقابل.",
    "ruleTableTitle1" : "قواعد مكافآت المشاركة كما يلي：",
    "ruleTableTitle2" : "قواعد مستوى الـVIP وهدايا قسائم التخفيضات كما بالصورة التالية:",
    "ruleTableHead1" : "معايير الشحن",
    "ruleTableHead2" : "معايير المكافآت",
    "ruleTableHead3" : "المكافأة",
    "ruleTableContent1" : "قم بدعوة 5 لاعبين جدد",
    "ruleTableContent2" : "وصول شحن اللاعبين الذين تم الربط بهم إلى 1000 دولار",
    "errorTip" : "فشل الربط",
    "eventShareText1" : "Puzzles & Survival: حدث تخفيضات متجر النهاية يجري الآن",
    "eventShareText2" : "الكثير من الفوائد بانتظارك",
    "cartDoubleTip" : "سلة المشتريات لا تدعم استخدام قسيمة المضاعفة في الوقت الحالي",
    "codeTip3" : "لم يتم تسجيل الدخول",
    "codeTip4" : "البيانات مفقودة",
    "codeTip5" : "لا يمكن ربط رقم الدعوة الخاص بك",
    "codeTip6" : "تم توليد رقم الدعوة",
    "payWelfare" : "فوائد الشحن",
    "wallet" : "المحفظة",
    "myDiscount" : "قسائم التخفيض",
    "knowMore" : "اعرف المزيد",
    "backPay" : "شحن العودة",
    "curBalance" : "الرصيد الحالي",
    "pay" : "شحن",
    "changeCoin" : "تغيير العملة",
    "watchDesc" : "عرض التفاصيل",
    "getMore" : "احصل على المزيد",
    "getDiscount" : "استلم قسيمة التخفيض",
    "notOpenDiscountQuan" : "لم يفتح حدث تخفيضات في الوقت الحالي، يرجى الانتظار",
    "abountZbit" : "بخصوص \${Z-BIT}",
    "remain" : "متبقي:",
    "payRemain" : "الرصيد المتوقع بعد الدفع",
    "payRemainExpiry" : "بعد الدفع، من المتوقع أن يتبقى ${money} (تنتهي صلاحيتها في 1 يناير 26، يرجى استخدامها في أقرب وقت ممكن)",
    "balanceNotEnoughExpiry" : "رصيد غير كافٍ (ينتهي في 1 يناير 26، لا يدعم إعادة الشحن)",
    "balanceNotEnoggh" : "الرصيد غير كافٍ، يرجى الشحن أولاً",
    "goToPay" : "التوجه للشحن",
    "chooseOtherPay" : "اختر طريقة شحن أخرى",
    "payIntro" : "معلومات الشحن",
    "logRole" : "سجل الدخول إلى الشخصية",
    "chooseProduct" : "اختر السلعة",
    "meAgree" : "لقد قرأت ووافقت على الشروط.",
    "coinAgreeText" : "",
    "aboutCoin" : "",
    "coinsPayTokenLogin" : "يتطلب المصادقة الثنائية قبل الاستخدام\${Z-BIT}",
    "dl3dvnVipRule1" : "1. الألعاب المتاحة:  \${gameName}",
    "dl3dvnVipRule2" : "كل نوع من هدايا الحدث يمكن استلامه مرة واحدة فقط.",
    "dl3dvnVipRule3" : "2. نشاط \"سجل دخولك واربح القسيمة\": قم بتسجيل الدخول إلى صفحة الشحن لأول مرة واحصل على قسيمة تخفيض 15٪.",
    "dl3dvnVipRule4" : "3. حدث نقاط VIP: اشترِ عنصر عبر صفحتنا الرسمية لكسب النقاط والحصول على كوبونات المستوى والكوبونات الأسبوعية.",
    "dl3dvnVipRule5" : "4. قد تختلف النقاط التي قد تكسبها وفقًا للعملة التي تستخدمها. لمزيد من التفاصيل، يرجى التحقق من الرابط في الأسفل.",
    "dl3dvnVipRule6" : "5. إذا تم استخدام كوبون تخفيض عند تنفيذ الطلب، فسيتم احتساب النقاط وفقًا للمبلغ الفعلي المدفوع.",
    "dl3dvnVipRule7" : "6. ستنتهي صلاحية النقاط التي حصلت عليها خلال 365 يومًا. قد يؤثر هذا على مستوى VIP الخاص بك.",
    "dl3dvnVipRule8" : "7. ستحصل على الفور على كوبون نظرًا للوصول إلى مستوى VIP لأول مرة. يمكن استلام الكوبون الأسبوعي الساعة 00:00 (UTC+0) كل يوم سبت.",
    "dl3dvnVipRule9" : "8. سوف تحتاج إلى تسجيل الدخول لاستلام الكوبون الأسبوعي. لا تفوت الفرصة!",
    "dl3dvnVipRule10" : "9. ستكون عملة الكوبون هي عملة آخر طلب قمت به. يرجى الاتصال بخدمة العملاء إذا كنت ترغب في تغيير العملة التي تستخدمها.",
    "dl3dvnVipRule11" : "10. راجع الجدول أدناه للحصول على مزيد من التفاصيل حول مستويات وكوبونات VIP.",
    "dl3dvnVipRule12" : "",
    "dl3dvnVipRule13" : "12. في حالة وجود أي نزاع، يكون لفريق دعم \${gameName} التقدير المنفرد والنهائي لتفسير هذه الشروط والأحكام.",
    "codeTip7" : "هذا اللاعب قد ربط رقم الدعوة الخاص بك، لا يمكنك استخدام رقم الدعوة الخاص به للربط ثانية.",
    "ruleText10" : "10. تحتفظ إدارة Puzzles & Survival الرسمية بأي حقوق للتفسير النهائي.",
    "payCoins" : "نقاط VIP الخاصة بالشحن",
    "shareGift" : "شارك واربح",
    "attentionCoinUse" : "ملحوظة: الرصيد بالعملات المختلفة ليس عام الاستخدام",
    "noPayWay" : "نعتذر لعدم توافر وسائل دفع في المنطقة التي قمت باختيارها، يرجى تغيير المنطقة ثم إعادة المحاولة",
    "dl3dtwVipRule1" : "1. الألعاب المتاحة:  \${gameName}",
    "dl3dtwVipRule2" : "كل نوع من هدايا الحدث يمكن استلامه مرة واحدة فقط.",
    "dl3dtwVipRule3" : "2. حدث نقاط VIP: اشترِ عنصر عبر صفحتنا الرسمية لكسب النقاط والحصول على كوبونات المستوى والكوبونات الأسبوعية.",
    "dl3dtwVipRule4" : "3. قد تختلف النقاط التي قد تكسبها وفقًا للعملة التي تستخدمها. لمزيد من التفاصيل، يرجى التحقق من الرابط في الأسفل.",
    "dl3dtwVipRule5" : "4. إذا تم استخدام كوبون تخفيض عند تنفيذ الطلب، فسيتم احتساب النقاط وفقًا للمبلغ الفعلي المدفوع.",
    "dl3dtwVipRule6" : "5. ستنتهي صلاحية النقاط التي حصلت عليها خلال 365 يومًا. قد يؤثر هذا على مستوى VIP الخاص بك.",
    "dl3dtwVipRule7" : "6. ستحصل على الفور على كوبون نظرًا للوصول إلى مستوى VIP لأول مرة. يمكن استلام الكوبون الأسبوعي الساعة 00:00 (UTC+0) كل يوم سبت.",
    "dl3dtwVipRule8" : "7. سوف تحتاج إلى تسجيل الدخول لاستلام الكوبون الأسبوعي. لا تفوت الفرصة!",
    "dl3dtwVipRule9" : "8. ستكون عملة الكوبون هي عملة آخر طلب قمت به. يرجى الاتصال بخدمة العملاء إذا كنت ترغب في تغيير العملة التي تستخدمها.",
    "dl3dtwVipRule10" : "9. راجع الجدول أدناه للحصول على مزيد من التفاصيل حول مستويات وكوبونات VIP.",
    "dl3dtwVipRule11" : "10. في حالة وجود أي نزاع، يكون لفريق دعم \${gameName} التقدير المنفرد والنهائي لتفسير هذه الشروط والأحكام.",
    "eventInviteSucc" : "تم إرسال الدعوة",
    "eventGainCondition" : "شروط الحصول عليها",
    "eventSuccInvite" : "دعوة صديق بنجاح",
    "eventInviteGainOne" : "وصول الشحن التراكمي لمتلقي الدعوة إلى 49.99 دولار",
    "eventInviteGainTwo" : "وصول الشحن التراكمي لمتلقي الدعوة إلى 99.99 دولار",
    "eventFriendCode" : "كود دعوة الصديق الخاص بك:",
    "eventCheckBind" : "ربط؟",
    "eventConfirm" : "تأكيد",
    "eventCancel" : "إلغاء",
    "eventBindSucc" : "تم الربط بنجاح!",
    "eventGainCoupon" : "لقد حصلت على قسيمة تخفيض!",
    "eventLookCoupon" : "عرض قسائم التخفيض",
    "eventSuccBind" : "تم الربط بنجاح",
    "recaptchaTip" : "يرجى إتمام التحقق أولاً.",
    "inputAccountName" : "يرجى إدخال الحساب الذي تود استعادته",
    "pwaPayTip" : "وصول سريع، تجربة أفضل",
    "pwsInstall" : "أضِف إلى الشاشة الرئيسية",
    "ztmslgType999" : "Voucher",
    "coinUseTips" : "سيتم إصدار القسائم على شكل رسائل بالبريد في اللعبة، مما يمكّنك من شراء أي منتج في متجر القسائم بداخل اللعبة. عندما تستهلك القسائم سيمكنك الحصول على مكافآت الشحن التراكمي.",
    "notice" : "إعلان",
    "popupConfirm" : "تأكيد",
    "hideWithinWeek" : "إخفاء لمدة 7 أيام",
    "ztmslgProductOffTips" : "في الآونة الأخيرة، تلقينا الكثير من التعليقات من اللاعبين المخلصين حول التحديث القادم لصفحة الدفع، ونحيط سيادتكم علما بأننا نولي أهمية كبيرة لصوت اللاعبين. تقرر الآن: إلغاء التغييرات التي كان من المقرر إطلاقها في الأصل في 13 مارس. سنواصل تحسين تجربة التسوق الخاصة بكم، شكرًا لتفهمكم ودعمكم! إذا كان لديكم أي أسئلة فيرجى التواصل مع خدمة العملاء.",
    "couponTopLimit" : "الحد الأقصى للتخفيض بمختلف العملات",
    "swsjpVipRule1" : "1. يبدأ الحدث في 00:00 (UTC) 2023/03/24",
    "swsjpVipRule2" : "2. الألعاب المتاحة: \${gameName}",
    "swsjpVipRule3" : "كل نوع من هدايا الحدث يمكن استلامه مرة واحدة فقط.",
    "swsjpVipRule4" : "3. نشاط \"سجل دخولك واربح القسيمة\": قم بتسجيل الدخول إلى صفحة الشحن لأول مرة واحصل على قسيمة تخفيض 15٪.",
    "swsjpVipRule5" : "4. حدث نقاط VIP: اشترِ عنصر عبر صفحتنا الرسمية لكسب النقاط والحصول على كوبونات المستوى والكوبونات الأسبوعية.",
    "swsjpVipRule6" : "5. قد تختلف النقاط التي قد تكسبها وفقًا للعملة التي تستخدمها. لمزيد من التفاصيل، يرجى التحقق من الرابط في الأسفل.",
    "swsjpVipRule7" : "6. إذا تم استخدام كوبون تخفيض عند تنفيذ الطلب، فسيتم احتساب النقاط وفقًا للمبلغ الفعلي المدفوع.",
    "swsjpVipRule8" : "7. لقد تم منحك بالفعل نقاطًا لعمليات الشراء التي قمت بها سابقًا.",
    "swsjpVipRule9" : "8. ستنتهي صلاحية النقاط التي حصلت عليها خلال 365 يومًا. قد يؤثر هذا على مستوى VIP الخاص بك.",
    "swsjpVipRule10" : "9. ستحصل على الفور على كوبون نظرًا للوصول إلى مستوى VIP لأول مرة. يمكن استلام الكوبون الأسبوعي الساعة 00:00 (UTC+0) كل يوم سبت.",
    "swsjpVipRule11" : "10. سوف تحتاج إلى تسجيل الدخول لاستلام الكوبون الأسبوعي. لا تفوت الفرصة!",
    "swsjpVipRule12" : "11. ستكون عملة الكوبون هي عملة آخر طلب قمت به. يرجى الاتصال بخدمة العملاء إذا كنت ترغب في تغيير العملة التي تستخدمها.",
    "swsjpVipRule13" : "12. في حالة وجود أي نزاع، يكون لفريق دعم \${gameName}  التقدير المنفرد والنهائي لتفسير هذه الشروط والأحكام.",
    "beautyVipRule1" : "",
    "beautyVipRule2" : "",
    "beautyVipRule3" : "",
    "beautyVipRule4" : "",
    "beautyVipRule5" : "",
    "beautyVipRule6" : "",
    "beautyVipRule7" : "",
    "beautyVipRule8" : "",
    "beautyVipRule9" : "",
    "beautyVipRule10" : "",
    "beautyVipRule11" : "",
    "antslgType999" : "Voucher",
    "passAskMods" : "اسأل MOD",
    "passAskModsTip" : "يمكنك سؤال mod عن كل ما يتعلق باللعبة.",
    "passService" : "سؤال خدمة العملاء",
    "passServiceTip" : "يرجى التواصل مع خدمة العملاء في حالة وجود مشاكل متعلقة بالحساب أو الشحن وما يماثلها.",
    "passIKonw" : "حسنًا",
    "passGoOn" : "استمرار الاستفسار",
    "voucherTitle" : "مركز الشحن الرسمي",
    "voucherAddHome" : "إضافة إلى سطح المكتب",
    "voucherAddHomeTipOne" : "دفع أسرع وتجربة أفضل",
    "voucherAddHomeTipTwo" : "اضغط (مشاركة) إلى شريط الأدوات",
    "voucherAddHomeTipThree" : "اختر (إضافة إلى سطح المكتب)",
    "voucherLoginLook" : "سجل دخولك لمشاهدة العروض",
    "voucherSwitchRole" : "تبديل الشخصية",
    "voucherCoupon" : "قسيمة",
    "voucherVip" : "نقطة VIP",
    "voucherMoreCoupon" : "المزيد من العروض",
    "voucherAccountId" : "معرّف الحساب",
    "voucherOtp" : "OTP",
    "voucherOtherWayPay" : "اختر طريقة أخرى للدفع",
    "voucherOtherLoginWay" : "حاول طريقة أخرى",
    "voucherCouponActivity" : "تخفيضات العروض",
    "voucherActivityNotBegin" : "الحدث لم يبدأ بعد.",
    "voucherGoCommunity" : "اعرف المزيد عن فعاليات الشحن من مجتمع اللاعبين.",
    "voucherValidTime" : "الصلاحية",
    "voucherLimitRegion" : "مع الشحن بعملة \${currency} فقط",
    "voucherLiuyi" : "لا توجد قسائم متاحة، يرجى متابعة الفعاليات القادمة.",
    "voucherPay" : "اشترِ قسائم التخفيض",
    "voucherAbout" : "عن القسيمة",
    "voucherChooseWay" : "اختر وسيلة الدفع",
    "voucherMoreWay" : "المزيد من وسائل الدفع",
    "voucherChooseCoupon" : "اختر القسيمة",
    "voucherHasChoose" : "تم اختيار",
    "voucherMoneyInsufficient" : "الرصيد غير كافٍ",
    "voucherContact" : "الرصيد غير كافٍ، يرجى التواصل مع فريق الدعم",
    "voucherCouponTotal" : "القسائم المتاحة",
    "voucherCouponTipGuide" : "يمكن استخدام القسائم للدفع بعد تحديد وسيلة الدفع.",
    "voucherPaytypeNotSupport" : "القسائم غير متوفرة لوسيلة الدفع هذه",
    "voucherTipSideOne" : "يمكن استبدال القسائم بجميع الحزم داخل اللعبة والخدمات ذات القيمة المضافة باستثناء القسيمة نفسها.",
    "voucherTipSideTwo" : "تخفيض حتى ١٥٪.",
    "voucherYue" : "الرصيد",
    "jpUidLoginName" : "",
    "jpUidToken" : "",
    "jpUidInputToken" : "",
    "pnsBook" : "سجل البقاء",
    "vipHeadText" : "VIP exclusive frame unlocked",
    "vipHeadGetText" : "Claim",
    "vipHeadGotText" : "Claimed",
    "vipHeadGetTitle" : "Confirm",
    "vipHeadGetTip" : "This reward can only be claimed once per account. Continue?",
    "vipHeadAwardText" : "القائد الذهبي (دائم)",
    "vipHeadGetErrTip1" : "Failed. Please try again or contact CS.",
    "cartGuideTipNew" : "أضف المزيد من العناصر لاستخدام القسيمة",
    "newVipTitle" : "مركز الشحن VIP",
    "newVipLogin" : "تسجيل الدخول",
    "newVipNowPoint" : "النقاط:",
    "newVipNextLevel" : "تحتاج \${point} من النقاط حتى تصل إلى المستوى التالي",
    "newVipUpgrade" : "ترقية",
    "newVipLevel" : "مزايا VIP",
    "newVipTip" : "سيتم تحديث القسائم في الساعة 00:00 (UTC) كل يوم سبت. سوف تحصل عليهم عند تسجيل الدخول على صفحة الشحن الرسمية.",
    "newVipWeekly" : "المكافأة الأسبوعية",
    "newVipReachPoint" : "المتطلبات:",
    "newVipRuleInfo" : "القواعد:",
    "pleaseLang" : "اختر لغة",
    "reference" : "رقم الطلب",
    "saveToNext" : "احفظ بيانات البطاقة البنكية",
    "cardNum" : "رقم البطاقة",
    "expireTime" : "صالحة حتى",
    "CVV" : "CVV",
    "pleaseCard" : "نوع البطاقة البنكية",
    "howToPay" : "كيف تريد الدفع؟",
    "checkCard" : "يرجى التحقق من رقم البطاقة",
    "checkExpiryDate" : "يرجى التحقق من تاريخ انتهاء البطاقة",
    "checkCVV" : "يرجى التحقق من الكود السري CVV للبطاقة",
    "addCard" : "جديد",
    "delete" : "حذف",
    "deleteCardTips" : "احذف بيانات البطاقة التي تم حفظها",
    "confirmDelete" : "تأكيد الحذف",
    "cancelDelete" : "إلغاء",
    "checkAllCardMsg" : "يرجى التأكد من إدخال رقم البطاقة الصحيح وتاريخ انتهاء الصلاحية و CVV.",
    "leaveCreditPageTips" : "De transactie wordt niet voltooid als u nu deze pagina verlaat. Toch verlaten?",
    "sureToLeave" : "Verlaten",
    "continueToPay" : "Doorgaan",
    "pushTest" : "اختبار الإشعارات",
    "getNoticication" : "لا تستطيع الحصول على إشعارات من اللعبة؟",
    "waitCheckResult" : "يرجى انتظار نتيجة الاختبار.",
    "hadAbnormal" : "تم العثور على حالة غير طبيعية قد تؤدي إلى فشل الإشعارات.",
    "clickIntro" : "اضغط على التقرير لعرض طريقة الحل",
    "networkCheck" : "اختبار الشبكة",
    "noticeAuthorityCheck" : "اختبار وصول الإشعارات",
    "noticeBtnCheck" : "اختبار شريط الإشعارات",
    "gmsCheck" : "اختبار خدمات GMS",
    "batteryCheck" : "اختبار تحسين استخدام البطارية",
    "pushServiceCheck" : "اختبار خدمات الإشعارات",
    "reCheck" : "إعادة الاختبار",
    "noNoticeAuthorityTip" : "لم يتم تمكين الوصول إلى الإشعارات على هذا الجهاز. انتقل إلى إعدادات النظام - الإشعارات لمنح الوصول إلى اللعبة.",
    "noNoticeBtnTip" : "شريط الإشعارات مقفل. يرجى القيام بتمكينه في إعدادات النظام.",
    "noBatteryTip" : "اللعبة مدرجة في قائمة تحسين استخدام البطارية، وقد لا تحصل على خدمة الإشعارات. يرجى الانتقال إلى إعدادات النظام - البطارية - تحسين استخدام البطارية لإضافة اللعبة إلى قائمة التطبيقات المسموح بها.",
    "noPushServiceTip" : "خادم الإشعارات غير متصل. انقر فوق [اتصال] لاستئناف الخدمة.",
    "noNetworkTip" : "اتصالك الحالي بالشبكة غير مستقر.",
    "noGmsTip" : "جهازك لا يدعم GMS. الرجاء استخدام جهاز متوافق مع GMS.",
    "pushConnectFail" : "تم قطع اتصال خادم الإشعارات.",
    "pushConnectSucc" : "تم توصيل خادم الإشعارات.",
    "noGetPushTitle" : "إذا كنت لا تزال غير قادر على تلقي إشعارات من اللعبة. الرجاء اتباع هذه الخطوات:",
    "noGetPushContOne" : "1. قم بتسجيل الخروج من اللعبة ثم تسجيل الدخول مرة أخرى على هذا الجهاز.",
    "noGetPushContTwo" : "2. انقر فوق [اختبار الإشعارات] لمحاولة إجراء اختبار. تحقق مما إذا كان جهازك يمكنه تلقي أي إشعارات اختبارية.",
    "noGetPushContThree" : "3. إذا كنت قد تلقيت إشعار الاختبار ولكنك لا تزال غير قادر على تلقي أي إشعارات أخرى، فيرجى تسجيل الدخول إلى اللعبة، والانتقال إلى الإعدادات - الإشعارات والتحقق مما إذا كانت جميع الإخطارات قيد التشغيل.",
    "noGetPushContFour" : "4. إذا كنت لا تزال غير قادر على تلقي أي إشعارات، فيرجى الاتصال بخدمة العملاء.",
    "getPushSucc" : "لقد تلقى جهازك إشعارًا اختباريًا. الخاصية تعمل بشكل طبيعي!",
    "allCheckSucc" : "تم إجراء اختبار الإشعارات. لم يتم العثور على أي أمر غير طبيعي!",
    "pushCheck" : "اختبار الإشعارات",
    "useDirectPay" : "استخدم الدفع السريع",
    "paypalFraudnetInfo" : "تتمتع معلومات الدفع بحماية أنظمة PayPal\nالشحن",
    "goToSetting" : "الإعدادات",
    "retry" : "أعد المحاولة",
    "connect" : "اتصال",
    "canRebind" : "يمكنك الربط مرة أخرى بعد فك الربط",
    "agreePlatform" : "لقد وافقت على \${service} و\${privite}.",
    "sendGameNews" : "اشترك في النشرات الإخبارية.",
    "canNotBindEmail" : "لن تتمكن من استخدام هذا البريد الإلكتروني لتسجيل الدخول بمجرد فك ارتباطه.",
    "canNotBindPhone" : "لن تتمكن من استخدام رقم الهاتف المحمول هذا لتسجيل الدخول بمجرد فك ارتباطه.",
    "canChangeByEmail" : "يمكنك تسجيل الدخول بالبريد الإلكتروني على أجهزة مختلفة.",
    "canChangeByPhone" : "يمكنك تسجيل الدخول باستخدام رقم الهاتف المحمول على أجهزة مختلفة.",
    "loginSucc" : "تم تسجيل الدخول",
    "phoneHadBind" : "تم بالفعل ربط رقم الهاتف المحمول. تسجيل الدخول به؟",
    "emailHadBind" : "تم بالفعل ربط البريد الإلكتروني. تسجيل الدخول به؟",
    "phoneNotBind" : "رقم الهاتف المحمول لم يتم ربطه بعد. هل تريد إنشاء حساب جديد؟",
    "emailNotBind" : "لم يتم ربط البريد الإلكتروني بعد. هل تريد إنشاء حساب جديد؟",
    "emailAccount" : "حساب البريد الإلكتروني",
    "phoneAccount" : "حساب الهاتف المحمول",
    "phoneInputError" : "رقم الهاتف المحمول غير صحيح",
    "registerNewAccount" : "تسجيل",
    "secureTip" : "نصائح حول أمان الحساب",
    "toTop" : "تثبيت بالأعلى",
    "createNewWork" : "مذكرة جديدة",
    "serviceEvaluate" : "قيّم الخدمة",
    "emailRemind" : "الإشعارات",
    "isAgreeService" : "ما مدى رضاك عن خدمتنا؟",
    "thankEvaluateTop" : "شكرا لك على ملاحظاتك!",
    "inputValidEmail" : "يرجى إدخال عنوان بريد إلكتروني صالح.",
    "replyWillRemind" : "سوف تتلقى رسالة بريد إلكتروني للإخطار عندما يتم الرد على سؤالك. اضغط مرة أخرى لإيقاف تشغيل هذه الخاصية.",
    "isCancelEmailRemind" : "لن تتلقى أي بريد إلكتروني للإخطار. الاستمرار للإيقاف؟",
    "reconfirmEmail" : "يرجى التأكيد على عنوان بريدك الإلكتروني.",
    "confirmCanSubmit" : "قم بالتأكيد لتقديم المذكرة",
    "serviceWillReply" : "سيتم إعلامك عبر البريد الإلكتروني عند قيام خدمة العملاء بالرد.",
    "cancelEmailRemind" : "إغلاق [الإشعارات]؟",
    "yes" : "نعم",
    "no" : "لا",
    "inputWorkSearch" : "بحث...",
    "loading" : "جارِ التحميل",
    "loadingError" : "فشل التحميل. يرجى إعادة التحميل مرة أخرى...",
    "noMore" : "لا يوجد المزيد",
    "cancelToTop" : "إزالة التثبيت",
    "evaluateOne" : "سيء جدًا",
    "evaluateTwo" : "سيء",
    "evaluateThree" : "محايد",
    "evaluateFour" : "جيد",
    "evaluateFive" : "ممتاز",
    "confirmDelWorkTop" : "حذف هذه المذكّرة؟",
    "reRemindEmail" : "هل تحتاج إلى إشعار عبر البريد الإلكتروني؟ فقط اضغط على زر [الإشعارات] مرة أخرى.",
    "confirmWillReply" : "قم بالتأكيد للموافقة على أن يتم إخطارك عبر البريد الإلكتروني عند رد خدمة العملاء.",
    "thankEvaluateBottom" : "",
    "confirmDelWorkBottom" : "لا يمكن استعادة المذكّرة المحذوفة.",
    "morePurchaseWay" : "",
    "purchaseNeed" : "",
    "videoUploadSucc" : "تم رفع الفيديو",
    "videoUploadFail" : "فشل رفع الفيديو",
    "videoUploadLimit" : "يرجى رفع ملفات mp4 بحجم أقل من 400 ميغابايت ولا تزيد مدتها عن دقيقتين.",
    "imageUploadSucc" : "تم رفع الصورة",
    "imageUploadFail" : "فشل رفع الصورة",
    "uploading" : "جارٍ التحميل",
    "smartOrderCreate" : "تذكرة سريعة",
    "smartOrderSearch" : "بحث",
    "smartOrderComing" : "آت قريباً",
    "smartOrderContactService" : "خدمة العملاء",
    "smartOrderDetector" : "المساعد",
    "smartOrderDetect" : "تشخيص",
    "smartOrderDetecting" : "جار التشخيص",
    "smartOrderDetectTip" : "تم اكتشاف مشكلة أثناء لعبك اللعبة. الرجاء الضغط على تشخيص حتى نتمكن من التعرف عليها.",
    "smartOrderDetectTip2" : "تم تحديد المشكلة. يرجى إرسال تذكرة حتى نتمكن من حل المشكلة لسيادتكم!",
    "smartOrderSubmit" : "تقديم",
    "smartOrderIKnow" : "حسنًا",
    "smartOrderConfirm" : "حسنًا",
    "smartOrderLook" : "عرض",
    "smartOrderIsHelp" : "هل كان هذا المقال ذو فائدة؟!",
    "smartOrderInputQuestion" : "قم بكتابة المشكلة التي واجهتها.",
    "smartOrderPleaseInpt" : "يرجى الإدخال",
    "smartOrderPleaseChoose" : "اختيار",
    "smartOrderStoreTime" : "وقت الشحن",
    "smartOrderInputOrder" : "يرجى إدخال رقم الطلب",
    "smartOrderInputPrice" : "يرجى إدخال القيمة النقدية للطلب",
    "smartOrderNeedHelp" : "كيف يمكنني مساعدتك؟",
    "smartOrderLookHelpTip" : "يمكنك الاطلاع على FAQ",
    "smartOrderNoResult" : "لا توجد نتائج. يرجى المحاولة باستخدام كلمة مفتاحية أخرى",
    "smartOrderUpdateTime" : "وقت آخر تعديل",
    "smartOrderSelectStoreTime" : "يرجى اختيار وقت الشحن",
    "smartOrderAtlestChoose" : "يرجى كتابة واحد على الأقل",
    "pwaInstallAward" : "Add Shortcut",
    "getMasonry" : "Claim Diamond",
    "addToDrawerVisit" : "Add a shortcut so you can easily find it again.",
    "immeAddToGet" : "Add shortcut now to claim limited rewards.",
    "add" : "Add Shortcut",
    "talkNextTime" : "Later",
    "chooseRoleGetGift" : "Select your character to claim rewards",
    "getGiftSuccess" : "Claimed. Go check your rewards in the game.",
    "dmaTitle" : "إعلانات مخصصة",
    "newAdd" : "جديد",
    "smartDelete" : "حذف",
    "wordLengthTip" : "(شخصيات 0-600)",
    "areaLimitSwitchRegion" : "تغيير المنطقة",
    "areaLimitCurrentRegionCurrency" : "المنطقة وعملة الدفع الحاليين",
    "areaLimitRegion" : "المنطقة:",
    "areaLimitCurrency" : "عملة الدفع:",
    "areaLimitNote" : "ملحوظة:",
    "areaLimitSwitchLimitation" : "يمكن للحساب تبديل المناطق مرة واحدة فقط في السنة",
    "areaLimitPostSwitchCoupon" : "بعد اكتمال التبديل، سيتم إصدار القسائم التي تم الحصول عليها حديثًا وفقًا للعملة المقابلة للمنطقة الجديدة.",
    "areaLimitRemainingSwitches" : "المحاولات المتبقية: \${times}",
    "areaLimitNoRemainingSwitches" : "لا توجد محاولات متبقية",
    "areaLimitUnableToSwitchThisYear" : "لا يمكن التعديل ثانية خلال اليوم",
    "areaLimitCannotSwitch" : "لا يمكن التعديل",
    "areaLimitNavigateToSwitch" : "اذهب للتعديل",
    "areaLimitConfirmSwitch" : "تأكيد التعديل",
    "areaLimitPreSwitchRegionCurrency" : "المنطقة وعملة الدفع قبل التغيير",
    "areaLimitPostSwitchRegionCurrency" : "المنطقة وعملة الدفع بعد التغيير",
    "areaLimitPostSwitchRestriction" : "بعد نجاح التبديل، لن يمكن تبديل منطقة الدفع مرة أخرى خلال هذا العام.",
    "areaLimitUnusedZBitWarning" : "لا يزال لديك Z-Bit غير مستخدمة. قد لا تتمكن من استخدام وحدات Z-Bit بعد تبديل المناطق. هل تريد المتابعة؟",
    "areaLimitConfirm" : "تأكيد",
    "areaLimitCancel" : "إلغاء",
    "areaLimitInconsistencyWarning" : "منطقة الوصول الخاصة بك غير متوافقة مع منطقة الدفع الخاصة بك",
    "areaLimitPromptToSwitch" : "تغيير المنطقة؟",
    "areaLimitEnterZipCode" : "*Please enter your zipcode",
    "areaLimitEnterInvalid" : "Zipcode is invalid, please re-enter",
    "areaLimitTaxRateTips" : "Depending on your location, the tax rate may vary, the payment amount shall prevail",
    "areaLimitInfoCollect" : "For information collection protection, please refer to the Privacy Policy",
    "getAward" : "Claim Reward",
    "selectProductTitle" : "اختر العنصر",
    "hotSuggest" : "رائج",
    "inputKeywordSearch" : "ابحث...",
    "lookProductContent" : "التفاصيل",
    "popupClose" : "إغلاق",
    "productSwitch" : "تبديل",
    "confirmBuy" : "شراء",
    "thinkLater" : "لاحقًا",
    "areaLimitConfirmRegion" : "تأكيد المنطقة",
    "areaLimitContinuePay" : "استمر في الدفع",
    "areaLimitSwitchLimitationTwice" : "يمكن للحساب تبديل المناطق مرتين فقط في السنة",
    "dtmslgVipRule1" : "1. الألعاب المتاحة:  \${gameName}",
    "dtmslgVipRule2" : "كل نوع من هدايا الحدث يمكن استلامه مرة واحدة فقط.",
    "dtmslgVipRule3" : "2. حدث نقاط VIP: اشترِ عنصر عبر صفحتنا الرسمية لكسب النقاط والحصول على كوبونات المستوى والكوبونات الأسبوعية.",
    "dtmslgVipRule4" : "3. قد تختلف النقاط التي قد تكسبها وفقًا للعملة التي تستخدمها. لمزيد من التفاصيل، يرجى التحقق من الرابط في الأسفل.",
    "dtmslgVipRule5" : "4. إذا تم استخدام كوبون تخفيض عند تنفيذ الطلب، فسيتم احتساب النقاط وفقًا للمبلغ الفعلي المدفوع.",
    "dtmslgVipRule6" : "5. ستنتهي صلاحية النقاط التي حصلت عليها خلال 365 يومًا. قد يؤثر هذا على مستوى VIP الخاص بك.",
    "dtmslgVipRule7" : "6. ستحصل على الفور على كوبون نظرًا للوصول إلى مستوى VIP لأول مرة. يمكن استلام الكوبون الأسبوعي الساعة 00:00 (UTC+0) كل يوم سبت.",
    "dtmslgVipRule8" : "7. سوف تحتاج إلى تسجيل الدخول لاستلام الكوبون الأسبوعي. لا تفوت الفرصة!",
    "dtmslgVipRule9" : "8. ستكون عملة الكوبون هي عملة آخر طلب قمت به. يرجى الاتصال بخدمة العملاء إذا كنت ترغب في تغيير العملة التي تستخدمها.",
    "dtmslgVipRule10" : "9. راجع الجدول أدناه للحصول على مزيد من التفاصيل حول مستويات وكوبونات VIP.",
    "dtmslgVipRule11" : "10. في حالة وجود أي نزاع، يكون لفريق دعم \${gameName} التقدير المنفرد والنهائي لتفسير هذه الشروط والأحكام.",
    "dtmslgType10010" : "Daily Discount",
    "dtmslgType10020" : "Limited Offer",
    "dtmslgType10030" : "Hero",
    "dtmslgType10040" : "Gear",
    "dtmslgType10050" : "Rune Challenge",
    "dtmslgType10060" : "Totem",
    "dtmslgType10070" : "Holystone",
    "dtmslgType10080" : "Dragon",
    "dtmslgType10090" : "Resource",
    "dtmslgType10100" : "Build & Tech",
    "dtmslgType10110" : "Rare",
    "dtmslgType10120" : "Curio",
    "dtmslgType10130" : "Diamond",
    "dtmslgType10140" : "Voucher",
    "dtmslgType2" : "Event Pack",
    "dtmslgType3" : "Rewards Center",
    "dtmslgType4" : "Pop-Up Pack",
    "dtmslgType5" : "Main Screen Pack",
    "dtmslgType20010" : "Black Friday Pack",
    "dtmslgType20021" : "5-Day Gift",
    "dtmslgTypeother" : "Other",
    "rightsIntro" : "",
    "213RightsIntro": "بسبب الخصائص الجديدة، سيتم إيقاف نشاط \"نقاط VIP\" السابق قريبًا.<br/>\n" +
        "يرجى استخدام القسائم التي تم الحصول عليها من نشاط \"نقاط VIP\" السابق في الوقت المناسب لتجنب تجاوز فترة صلاحية القسيمة.<br/>\n" +
        "وقت الإيقاف: 19-08-2024 08:00:00 (التوقيت العالمي)<br/>\n" +
        "بعد أن يتم وقف الحدث، يمكنك الذهاب إلى مركز VIP لتجربة المزيد من الصلاحيات:<br/>\n" +
        "أكمل المهام لتربح النقاط، والتي يمكن استبدالها بقسائم وعناصر باللعبة ومكافآت أخرى! هناك أيضًا الصلاحيات الحصرية للـ VIP وسحب النقاط وأنشطة المزايا الأخرى.<br/>\n" +
        "آتٍ قريبًا",
    "263RightsIntro": "بسبب الخصائص الجديدة، سيتم إيقاف نشاط \"نقاط VIP\" السابق قريبًا.<br/>\n" +
        "يرجى استخدام القسائم التي تم الحصول عليها من نشاط \"نقاط VIP\" السابق في الوقت المناسب لتجنب تجاوز فترة صلاحية القسيمة.<br/>\n" +
        "وقت الإيقاف: 28-09-2024 00:00:00 (التوقيت العالمي)<br/>\n" +
        "بعد أن يتم وقف الحدث، يمكنك الذهاب إلى مركز VIP لتجربة المزيد من الصلاحيات:<br/>\n" +
        "أكمل المهام لتربح النقاط، والتي يمكن استبدالها بقسائم وعناصر باللعبة ومكافآت أخرى! هناك أيضًا الصلاحيات الحصرية للـ VIP وسحب النقاط وأنشطة المزايا الأخرى.<br/>\n" +
        "آتٍ قريبًا",
    "goToRights" : "اذهب إلى مركز الأعضاء الرئيسيين",
    "oldVipIntro" : "يرجى استخدام القسائم التي تم الحصول عليها من نشاط \"نقاط VIP\" السابق في الوقت المناسب لتجنب تجاوز فترة صلاحية القسيمة.",
    "pwa-20001" : "يرجى تسجيل الدخول أولاً",
    "pwa-20002" : "المعامل غير صحيح",
    "pwa-20003" : "لم يتم ربط الشخصية",
    "pwa-20004" : "فشل إرسال المكافأة، يرجى المحاولة ثانية أو التواصل مع خدمة العملاء",
    "pwa-20005" : "لقد استلمت بالفعل هذه الحزمة",
    "pwa-20100" : "الحدث لم يبدأ بعد",
    "pwa-20101" : "انتهى الحدث",
    "pwa-20102" : "لم يحن بعد وقت استلام المكافآت",
    "pwa-20103" : "انتهى وقت الاستلام",
    "pwa-1001" : "عملية مكررة",
    "pwaCommon" : "يرجى المحاولة لاحقًا",
    "zipCodeSwitchZipCode" : "Switch ZIP Code",
    "zipCodeState" : "state",
    "zipCodeRate" : "rate",
    "-" : "-",
    "officialStore": "مركز الشحن الرسمي",
    "headerSafeTip": "آمن وخالي من المخاطر معاملات فورية",
    "safeChecking": "...جارِ فحص بيئة الدفع الحالية",
    "safeChecked": "آمن للاستخدام",
    "riskChecked": "تم اكتشاف خطر محتمل، تابع بحذر",
    "footerSafeTitle1": "آمن",
    "footerSafeTitle2": "مريح",
    "footerSafeTitle3": "اقتصادي",
    "footerSafeTitle4": "فعال",
    "footerSafeContent1": "مركز الشحن الرسمي",
    "footerSafeContent2": "يدعم طرق دفع متعددة",
    "footerSafeContent3": "عروض التخفيضات، والمزيد من الفوائد لفترة محدودة",
    "footerSafeContent4": "معاملات فورية، دون تأخير",
    "limitedTimeActivityTitle" : "Time-Limited Benefits",
    "limitedTimeActivityTime" : "Event Duration:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivityTaskProcess" : "(Currently \${curPay}/\${targetPay})",
    "limitedTimeActivityRateTips" : "(Exchange rates may vary, please refer to this page for accurate information)",
    "limitedTimeActivityNotAchieve" : "Not Completed",
    "limitedTimeActivityClaim" : "Claim",
    "limitedTimeActivityClaimed" : "Claimed",
    "limitedTimeActivityTimeLeft" : "Time-Limited: \${days}d \${hours}h \${minutes}m \${seconds}s",
    "limitedTimeActivityRecord" : "Claim Records",
    "limitedTimeActivityAward" : "Rewards",
    "limitedTimeActivityGotTime" : "Time Claimed",
    "limitedTimeActivityGotRole" : "Character Claimed",
    "limitedTimeActivityRule" : "Event Rules",
    "limitedTimeActivity285Rule1" : "1. Event Duration:  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivity285Rule2" : "2. During the event, complete time-limited tasks to claim rewards. Tasks are categorized into weekly and monthly tasks:",
    "limitedTimeActivity285Rule3" : "(1) Weekly Tasks: Each account is limited to completing one weekly task a week, resetting every Monday at 0:00.",
    "limitedTimeActivity285Rule4" : "Weekly Log in Task: Within the limited time, log in to the official website\'s top up page once.",
    "limitedTimeActivity285Rule5" : "Top up any amount: Within the limited time, top up any amount via the official website.",
    "limitedTimeActivity285Rule6" : "(2) Monthly Tasks: Each account is limited to one monthly task a month, resetting on the 1st of each month at 0:00.",
    "limitedTimeActivity285Rule7" : "Log in Task: Within the limited time, log in to the official website\'s top up page once.",
    "limitedTimeActivity285Rule8" : "Accumulative Top Up Task: Within the limited time, top up the required amount to claim a reward once.",
    "limitedTimeActivity285Rule9" : "Note: Due to the long duration of the event, exchange rates may fluctuate. Please refer to the displayed amount on the page for the top up amount.",
    "limitedTimeActivity285Rule10" : "3. Select a character before claiming a reward. You can find your rewards in-game after claiming them.",
    "limitedTimeActivityClaimAward" : "Claim Reward",
    "limitedTimeActivityConfirmGot" : "Confirm Claim",
    "limitedTimeActivityGetSucc" : "Claim Successful",
    "limitedTimeActivityGetFail" : "Claim Failed. Please try again later or contact customer service.",
    "limitedTimeActivityFrequent" : "Please avoid frequent actions.",
    "limitedTimeActivityLoginFirst" : "Please log in first.",
    "limitedTimeActivityWrongParam" : "Parameter Error",
    "limitedTimeActivityOverTips" : "The event has expired. Please refresh the page.",
    "preRightsIntro" : "بسبب الخصائص الجديدة، سيتم إيقاف نشاط \"نقاط VIP\" السابق قريبًا.<br/>وقت الإيقاف: \${offLineDate}<br/>يرجى استخدام القسائم التي تم الحصول عليها من نشاط \"نقاط VIP\" السابق في الوقت المناسب لتجنب تجاوز فترة صلاحية القسيمة.<br/>بعد أن يتم وقف الحدث، يمكنك الذهاب إلى مركز VIP لتجربة المزيد من الصلاحيات:<br/>أكمل المهام لتربح النقاط، والتي يمكن استبدالها بقسائم وعناصر باللعبة ومكافآت أخرى! هناك أيضًا الصلاحيات الحصرية للـ VIP وسحب النقاط وأنشطة المزايا الأخرى.<br/>آتٍ قريبًا",
    "riskTipTitle" : "احترس من السلوكيات غير القانونية ومخاطر الاحتيال",
    "riskTipContent" : "عزيزي اللاعب،\n\nلاحظنا مؤخرًا أن بعض اللاعبين انخرطوا في سلوكيات غير قانونية وسيئة في اللعبة مما أدى إلى التأثير بالسلب على نظام اللعبة وعدالتها، ومن بين هذه السلوكيات الشائعة ما يلي:\n\n1. نشر إعلانات غير قانونية: نشر إعلانات غير قانونية من خلال الدردشة والقنوات الأخرى، مثل معاملات الموارد غير القانونية، والشحن غير القانوني، وما إلى ذلك؛\n2. استخدام برامج الغش أو برامج النصوص البرمجية: استخدم الوسائل التقنية مثل برامج الغش أو برامج النصوص البرمجية في اللعبة للحصول على دفعات كبيرة من الموارد في انتهاك للوائح؛\n3. الدعوات غير القانونية: إرسال دعوات غير قانونية لا علاقة لها بمحتوى اللعبة أثناء الدردشة، بغرض الاتصال عبر قنوات خارج اللعبة (مثل Line وDiscord)؛\n4. الشحن غير القانوني: استخدام خصومات الشحن كطعم لتوجيه اللاعبين إلى إجراء عمليات شحن غير رسمية؛\n5. أشكال الاحتيال الأخرى، مثل انتحال صفة موظفين رسميين وغيرها.\n\nنود تذكير جميع اللاعبين بحماية ممتلكاتهم ومعلوماتهم الشخصية وعدم تصديق أي معلومات غير قانونية أو احتيالية أبدًا. هناك العديد من المخاطر في الانتهاكات المذكورة أعلاه، والتي قد لا تعرضك لخطر سرقة الحساب فحسب، بل قد تنطوي أيضًا على الاحتيال. نحن لا ندعم أي تعويض عن الخسائر الناجمة عن الانتهاكات.\n\nبالنسبة للحسابات التي تنتهك اللوائح، سنتخذ إجراءات بناءً على مدى خطورة الانتهاك ونطاقه، بما في ذلك على سبيل المثال لا الحصر، التحذيرات، وخصم الأرباح غير القانونية، والحظر المؤقت أو الدائم لحسابات اللعبة، وما إلى ذلك. إذا واجهت أي سلوك مشبوه في اللعبة، يمكنك إبلاغنا به عن طريق الاتصال بخدمة العملاء. سوف نتحقق في أقرب وقت ممكن ونتخذ التدابير في الوقت المناسب. نشكرك على تفهمك ودعمك.",
    "linkValid": "الرابط منتهي الصلاحية",
    "-" : "-",
    "accountLabel": "الحساب",
    "passwordLabel": "كلمة السر",
    "confirmPasswordLabel": "تأكيد كلمة السر",
    "confirmDeleteTitle" : "يرجى تأكيد ما إذا كنت تريد حذف حساب اللعبة وجميع الشخصيات الموجودة ضمن الحساب",
    "confirmDeleteYes" : "نعم، تأكيد حذف حساب اللعبة وجميع الشخصيات الموجودة ضمنه",
    "selectGame" : "الرجاء اختيار لعبة",
    "confirmDeleteNo" : "لا، أنا فقط بحاجة إلى حذف شخصية ما والاحتفاظ بحساب اللعبة",
    "delTermsTitle" : "يرجى قراءة شروط وتعليمات حذف الحساب بعناية.",
    "delCondTitle" : "1. شروط حذف الحساب",
    "delCond1" : "(1) تم تسجيل حساب اللعبة هذا وشخصية اللعبة التي ينتمي إليها واستخدامها بواسطتك يرجى تسجيل الدخول إلى الحساب قبل التقدم بالطلب. إذا تعذر تسجيل الدخول إلى الحساب، فيرجى [استرجاع الحساب] أولاً.",
    "delCond2" : "(2) لا يحتوي حساب اللعبة وشخصيات اللعبة المندرجة تحته على أي مخاطر أمنية، بما في ذلك على سبيل المثال لا الحصر: عدم وجود شكاوى أو تقارير أو تحقيقات أو تحكيم أو دعاوى قضائية لم تتم معالجتها، أو شكوى لم يتم التعامل معها، أو قد يكون تم الإبلاغ عنه، والتحقيق فيه، والتحكيم ضده، وتقديم شكوى ضده، ومقاضاته، وما إلى ذلك.",
    "delCond3" : "(3) لا توجد مستحقات غير مدفوعة على حساب اللعبة هذا وشخصية اللعبة المقابلة يجب تسويته، بما في ذلك على سبيل المثال لا الحصر المبالغ المستردة غير المسددة والاشتراكات غير الملغاة وما إلى ذلك.",
    "delNoticeTitle" : "2. تعليمات حذف الحساب",
    "delNotice1" : "(1) ما تقوم بطلب حذفه هو حساب اللعبة وشخصية اللعبة المنتمية له، بمجرد اكتمال الحذف، لن يمكنك تسجيل الدخول أو استعادته .",
    "delNotice2" : "(2) يرجى أولاً تسوية الأصول داخل اللعبة الموجودة ضمن حسابك وشخصيتك، بما في ذلك على سبيل المثال لا الحصر، عناصر اللعبة، وعملات اللعبة، والاشتراكات داخل اللعبة، وما إلى ذلك. بمجرد اكتمال الحذف، سيتم حذف جميع الأصول الموجودة في اللعبة بعد إيقاف خادم اللعبة، ولن يتم رد أي مبالغ للحسابات المحذوفة وشخصياتها.",
    "delNotice3" : "(3) بمجرد حذف حساب اللعبة وبيانات الشخصية الخاصة به، سيتم أيضًا حذف المعلومات ذات الصلة الموجودة ضمن الحساب أو إخفاء هويتها، ومع ذلك، يُطلب من اللاعبين إلغاء ربط معلومات تسجيل الدخول إلى الوسائط الاجتماعية التابعة لجهة خارجية (مثل تسجيل الدخول المرتبط بـ Facebook، إلخ) بأنفسهم، وحذف البيانات ذات الصلة من تلك المنصات.",
    "delNotice4" : "(4) من أجل حماية حقوقك ومصالحك، سنوفر لك فترة احتفاظ مدتها 14 يومًا (باستثناء اللوائح المحلية في بعض المناطق)، وهي فترة انتظار، يمكنك تلك الفترة التواصل مع خدمة العملاء لتقديم طلب إلغاء الحذف.",
    "delNotice5" : "(5) بمجرد تقديم طلب حذف حسابك سنقوم بتجميده على الفور، ولكن سيستغرق حذف البيانات حوالي أسبوع، لذلك سنخطرك عبر البريد الإلكتروني في أقرب وقت ممكن بعد الحذف الكامل.",
    "delFormConfirm1" : "لقد قرأت بعناية وفهمت شروط وعواقب حذف حسابي.",
    "delFormConfirm2" : "لا توجد بلاغات أو دعاوى قضائية معلقة ذات صلة بالحساب الذي طلبت حذفه.",
    "delForm" : "لقد قرأت ووافقت على <a class=\"account-delete-link\" href=\"javascript:;\">\"اتفاقية إلغاء الحساب\"</a>",
    "cannotDeleteMsgTitle" : "لا يمكن حذف الحساب",
    "cannotDeleteMsg1" : "لا يمكن حذف الحساب لأن حسابك لا يستوفي الشروط التالية:",
    "cannotDeleteMsg2" : "لقد اكتشف النظام أن لديك شكوى لم تتم معالجتها، برجاء تقديم الطلب مرة أخرى بعد استكمال شكوى.",
    "cannotDeleteMsg3" : "اكتشف النظام أن لديك مبلغ مسترد لم يتم تسويته بالكامل بعد، يرجى استكمال عملية استرداد المبلغ قبل تقديم طلب حذف الحساب.",
    "cannotDeleteMsg4" : "لقد اكتشف النظام أنه تم تقديم شكوى أو إبلاغ عنك من قبل لاعبين آخرين، يرجى الانتظار حتى اكتمال الشكوى وإرسال طلبك مرة أخرى.",
    "formCompleted" : "اكتملت الطلبية",
    "formCheckMsg1" : "لقد تم ملء طلبيتك، يرجى الانتظار حتى تقوم خدمة العملاء بمراجعتها يدويًا ثم الرد عليها.",
    "formCheckMsg2" : "يمكنك التحقق من تقدم معالجة الطلبية في <span class=\"account-delete-link\">[طلبياتي]</span>.",
    "delEmailMsg1" : "هل تريد أن يتم إعلامك عبر البريد الإلكتروني بعد اكتمال الحذف؟",
    "delEmailMsg2" : "نظرًا لأن حذف الحساب يتطلب معالجة كمية كبيرة من البيانات، فسوف يستغرق الأمر حوالي أسبوع لإكمال الحذف الكامل. هل تريد منا أن نخطرك عبر البريد الإلكتروني بعد اكتمال الحذف الكامل؟",
    "delEmailMsg3" : "يتم استخدام عنوان البريد الإلكتروني الذي تملأه فقط للإخطار ولن يتم استخدامه لأغراض أخرى.",
    "delEmailConfirmYes" : "نعم، يرجى إعلامي عن طريق البريد الإلكتروني",
    "delEmailFill" : "يرجى ملء بريد الإخطار الإلكتروني",
    "delEmailConfirmNo" : "لا، ليس هناك حاجة لإخطار عبر البريد الإلكتروني",
    "delCoolMsg1" : "هل تريد اختيار فترة الانتظار البالغة 14 يومًا؟",
    "delCoolMsg2" : "خلال تلك الفترة، سيتم تجميد حسابك ولكن يمكنك التقدم بطلب لإلغاء الحذف في أي وقت. وإذا لم تقم بالإلغاء بعد 14 يومًا، فسيتم حذف الحساب ول",
    "delCoolMsg3" : "ن تمكن استعادته.",
    "delCoolConfirmYes" : "إذا اخترت عدم الحاجة إلى فترة الانتظار، فسيتم حذف حسابك بعد اكتمال الطلب ولن تمكن استعادته.",
    "delCoolConfirmNo" : "لا، أريد حذفه الآن",
    "delSecondCheckMsg1" : "هل أنت متأكد من أنك قمت بمعالجة جميع محتويات حسابك وتقوم الآن بتنفيذ فترة انتظار حذف الحساب؟ لن يمكن تسجيل الدخول إلى حسابك بعد التنفيذ.",
    "delSecondCheckConfirmYes" : "نعم، ابدأ الآن",
    "delResMsg1" : "لقد تم إرسال طلب حذف حسابك. تم تجميد الحسابات التالية ولا يمكن تسجيل الدخول:",
    "gameName" : "اسم اللعبة:",
    "gameAccount" : "حساب اللعبة:",
    "delResMsg2" : "يرجى التقاط لقطة شاشة ونسخ معلومات الحساب أعلاه إذا كنت بحاجة إلى استعادة حسابك أثناء فترة الانتظار، فهذا هو الدليل الوحيد",
    "delResMsg3" : "فترة الانتظار هي 14 يومًا إجمالاً، العد التنازلي:",
    "delResMsg4" : "إذا كنت بحاجة إلى إلغاء طلب الحذف أثناء فترة الانتظار، فيرجى النقر فوق [اتصل بخدمة العملاء] أدناه أثناء فترة الانتظار.",
    "copyAccountInfo" : "نسخ معلومات الحساب",
    "delResMsg5" : "لقد أكملت طلب حذف الحساب. الحساب قيد الحذف حاليًا، لذلك لا يمكن تسجيل الدخول إلى حسابك من الآن فصاعدًا،",
    "delResMsg6" : "نظرًا لأن حذف الحساب يتطلب معالجة كمية كبيرة من البيانات وتستغرق المعالجة وقتًا، فلن يتم حذف جميع آثار الحساب لحظيًا وسوف نكتمل تلك العملية في غضون أسبوع تقريبًا.",
    "delResMsg7" : "إذا ملأت عنوان البريد الإلكتروني للإخطار من قبل، فسنرسل بريدًا إلكترونيًا إلى عنوان بريدك الإلكتروني المحدد.",
    "delResMsg8" : "إذا كنت بحاجة إلى تسجيل الدخول إلى اللعبة مرة أخرى، يمكنك تسجيل حساب جديد وتسجيل الدخول مرة أخرى.",
    "appleOption" : "App Store",
    "googleOption" : "Google Play",
    "otherOption" : "قنوات أخرى",
    "itemWrong" : "يوجد خطأ في ملء هذا العنصر، يرجى إعادة الإدخال.",
    "delRegisterTime" : "وقت التسجيل",
    "delDevice" : "الأنواع شائعة الاستخدام",
    "delIp" : "عنوان IP المستخدم عادة",
    "delHistoryPayChannel" : "قنوات الشحن التاريخية",
    "delHistoryPayOrder" : "رقم طلب شحن قديم",
    "delDeleteReason" : "سبب حذف الحساب",
    "delPrevStep" : "الخطوة السابقة",
    "delNextStep" : "الخطوة التالية",
    "delSecondCheckMsg2" : "هل أنت متأكد من معالجتك لجميع محتويات الحساب والقيام بحذفه الآن؟ لن يمكن تسجيل الدخول إلى حسابك بعد التنفيذ.",
    "pleaseFillIn" : "يرجى ملء البيانات التالية",
    "switchNewVersion": "تحويل للإصدار الجديد من",
    "switchNewVersionPlatform": "منصة الدفع",
    "updateVersionPopupContent": "لضمان أداء سلس للعبة ودعم الميزات الجديدة اللاحقة، نوصي بترقية نظام الجهاز الخاص بك للاستمتاع بتجربة تشغيل أكثر استقرارًا وتحسين التوافق.",
    selectTopupTips:"90% من المستخدمين يختارون مركز الشحن الرسمي",
    chuzhi: "رصيد",
    selectMethods: "طريقة الدفع",
    landscapeTip2: "يرجى تدوير هاتفك إلى الوضع العمودي للحصول على تجربة أفضل",
    v3LaunchFromDesktopAndRewardToMailbox: 'يرجى التشغيل من سطح المكتب\nاختر الشخصية وسيتم إرسال المكافأة إلى صندوق البريد',
    ckoNotAvailable: 'خطأ في خدمة الدفع، يرجى المحاولة مرة أخرى لاحقًا.',
    ckoSubmitFail: 'فشل الدفع. يرجى التحقق من معلوماتك أو استخدام بطاقة أخرى. إذا تم الخصم، سيتم استرداد المبلغ إلى وسيلة الدفع الأصلية.',
    gotoFinish: 'اذهب وأكمل'
}